
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2veNk", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $7c6f63f776b237bf$export$a9a1f3ad281c228; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $bTseT = parcelRequire("bTseT");

var $2CYZS = parcelRequire("2CYZS");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $28AH4 = parcelRequire("28AH4");

var $ik40B = parcelRequire("ik40B");
const $7c6f63f776b237bf$export$a9a1f3ad281c228 = (props)=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate('gwp-737-enable-intercom-chat-confluence');
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(props.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            screenName: "wacConfluenceProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CYZS.ConfluenceSoftwarePageTemplate), {
                pricing: props.pricing,
                availableProducts: props.availableProducts,
                userProfile: props.userProfile,
                keyword: props.keyword,
                subAnchor: props.subAnchor,
                useCase: props.useCase,
                utmMedium: props.utmMedium,
                utmContent: props.utmContent,
                utmCampaign: props.utmCampaign
            })
        })
    });
};

});
parcelRegister("2CYZS", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageTemplate", function () { return $9372a819789dd781$export$6a834c6096a76a8; });

var $7VQPk = parcelRequire("7VQPk");

var $a7tOB = parcelRequire("a7tOB");
const $9372a819789dd781$export$6a834c6096a76a8 = (props)=>{
    const ConfluenceSoftwarePageComponent = (0, $a7tOB.ConfluenceSoftwarePage);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceSoftwarePageComponent, {
        ...props
    });
};

});
parcelRegister("a7tOB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $e091e31db171d4e1$export$a9a1f3ad281c228; });
/* confluence-software-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $6gVNd = parcelRequire("6gVNd");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $l4vdU = parcelRequire("l4vdU");

var $9AKFZ = parcelRequire("9AKFZ");

var $3JYqW = parcelRequire("3JYqW");

var $izdHQ = parcelRequire("izdHQ");

var $5S2vX = parcelRequire("5S2vX");

var $FlsVD = parcelRequire("FlsVD");

var $hCHU3 = parcelRequire("hCHU3");

var $bCAvd = parcelRequire("bCAvd");

var $heBZG = parcelRequire("heBZG");

var $2Jr3C = parcelRequire("2Jr3C");

var $592OP = parcelRequire("592OP");

var $cWN5u = parcelRequire("cWN5u");

var $hswtB = parcelRequire("hswtB");

var $4sY9l = parcelRequire("4sY9l");

var $5v7eV = parcelRequire("5v7eV");

var $bFVFT = parcelRequire("bFVFT");

var $iuSIG = parcelRequire("iuSIG");

var $kkULZ = parcelRequire("kkULZ");
const $e091e31db171d4e1$var$relativeParent = null;
const $e091e31db171d4e1$var$relativeChildren = null;
const $e091e31db171d4e1$var$backgroundShape = null;
const $e091e31db171d4e1$var$ConfluenceSoftwarePageComponent = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $6gVNd.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $6gVNd.AtlSiteType).CONFLUENCE
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $l4vdU.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9AKFZ.ConfluenceAboveNavButterbar), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "confluence-software-page-cfind-1234",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3JYqW.ConfluencePageBanner), {}),
                            shouldShowLogMeIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                                confluenceSites: recentSites,
                                userProfileName: userProfileName
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $592OP.default), {
                                userProfile: userProfile
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bCAvd.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5v7eV.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4sY9l.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bFVFT.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkULZ.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuSIG.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1bah1h6o _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_mkrz1cp6 _bfhkg7ng _kqswstnw _152tidpf _1reo15vq _18m915vq _1bsb1wqz _4t3i16il _197pglyw _1knecv93"
                                        ]),
                                        style: {
                                            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _kqswh2mm _1pfh1ymo _zulpmxpn _2osn1sxy _1iyeviql"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cWN5u.default), {}),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FlsVD.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Jr3C.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $heBZG.default), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};
const $e091e31db171d4e1$export$a9a1f3ad281c228 = (0, $izdHQ.withFeatureExposed)('cfind-1234-product-tour-refresh-q3fy24', 'Test', $e091e31db171d4e1$var$ConfluenceSoftwarePageComponent);

});
parcelRegister("9AKFZ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceAboveNavButterbar", function () { return $6ed1c9c1b57dfc0f$export$86417e4293705c14; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");

var $dEFIL = parcelRequire("dEFIL");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $6ed1c9c1b57dfc0f$export$86417e4293705c14 = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp5090BannerExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === 'enrolled' && gwp5090BannerExperiment.value === 'butterbar';
    const gwp5090Team25Config = {
        identifier: 'GWP5090.confluence-product-tour.butterbar',
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        productKey: 'home',
        backgroundPreset: 'gwp-5090-banners',
        imageProps: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp',
            alt: 'Team25',
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: 'team25-banners-and-butterbars.confluence.cta',
            defaultMessage: 'Get your pass'
        }),
        linkUrl: 'https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653',
        dataEventProps: {
            'data-product-key': 'home',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': intl.formatMessage({
                id: 'team25-banners-and-butterbars.confluence.cta',
                defaultMessage: 'Get your pass'
            }),
            'data-label-english': 'Get your pass'
        }
    };
    return gwp5090IsButterBar ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), {
        ...gwp5090Team25Config
    }) : null;
};

});

parcelRegister("3JYqW", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageBanner", function () { return $eb1962f2e68aa697$export$88cfc9a6a95640d1; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $jVACb = parcelRequire("jVACb");

var $jQ0cd = parcelRequire("jQ0cd");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $eb1962f2e68aa697$export$88cfc9a6a95640d1 = ()=>{
    const intl = (0, $8e22h.default)();
    const showAiBanner = (0, $3L8ZR.default).checkGate('wac-uip-butter-bar-confluence-gate');
    const gwp5090BannerExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment !== undefined && gwp5090BannerExperiment.type === 'enrolled' && gwp5090BannerExperiment.value === 'butterbar';
    const aiBannerMessages = {
        identifier: 'ConfluenceSoftwarePageTemplate.atlassian-intelligence_exp',
        text: intl.formatMessage({
            id: 'ConfluenceSoftwarePageTemplate.banner-alert.atlassian-intelligence_exp',
            defaultMessage: 'Transform teamwork with Atlassian Intelligence - now available.'
        }),
        linkText: intl.formatMessage({
            id: 'ConfluenceSoftwarePageTemplate.link-text',
            defaultMessage: 'Learn more'
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/software/artificial-intelligence'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Learn more',
            'data-label-english': 'Learn more',
            'data-track-event': 'confluencePageBanner.announcementBanner.learnMore'
        }
    };
    return !gwp5090IsButterBar && showAiBanner ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...aiBannerMessages
    }) : null;
};

});

parcelRegister("FlsVD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $64d774ca96291cd1$export$2e2bcd8739ae039; });
/* ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $irfTW = parcelRequire("irfTW");

var $6YfJw = parcelRequire("6YfJw");

var $je135 = parcelRequire("je135");
const $64d774ca96291cd1$var$AISection = ()=>{
    const intl = (0, $8e22h.default)();
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const { ref: ref } = (0, $je135.useScrollTracking)('AISection', {
        observerOptions: {
            threshold: 0.25
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-aiSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: ref,
            className: (0, $2jatx.default)([
                "_12l0y52h _46zeidpf _168b1l27 _ztwyidpf _1y1e1l27 _1brwstnw _1bzd9by0 _15w9stnw _j19k12am _voa41wug _19xgidpf _thu2fatv _1kplidpf _1p4vfatv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irfTW.Ai), {
                    theme: "light",
                    title: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.title',
                        defaultMessage: 'Leave the busywork to AI'
                    }),
                    videoLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/50m38s3ne34430160w3lr4jcg67ykb0t.mp4",
                    includeFooter: false,
                    button: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                        intentType: 'button',
                        containerId: 'aiSection',
                        productKey: 'confluence',
                        edition: 'free',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            size: "large",
                            dataEventProps: {
                                'data-product-key': 'confluence',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'aiSection',
                                'data-label': 'explore-atlassian-intelligence',
                                'data-label-english': 'Explore Atlassian Intelligence',
                                'data-track-event': 'confluence-pt.ai.explore-atlassian-intelligence'
                            },
                            onClick: ()=>setIsModalOpen(true),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "ConfluenceSoftwarePage.v4.AISection.button",
                                defaultMessage: "Explore Atlassian Intelligence"
                            })
                        })
                    }),
                    buttonPosition: "bottom",
                    videoContainerClassName: 'video-container',
                    showBurst: true,
                    burstClassName1: 'burst-container1',
                    burstClassName2: 'burst-container2',
                    videoClassName: 'video'
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YfJw.YoutubeModal), {
                    isOpen: isModalOpen,
                    closeModal: ()=>setIsModalOpen(false),
                    src: "https://www.youtube.com/embed/ivIV1a8W0e4?si=iNOFdEMuDzTKN4X_?autoplay=1&rel=0&origin=https%3A%2F%2Fwww.atlassian.com&widget_referrer=https%3A%2F%2Fwww.atlassian.com&enablejsapi=1&widgetid=1&autoplay=1",
                    title: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.ModalYouTubeIframeTitle',
                        defaultMessage: 'Empower Teams with Atlassian Intelligence in Confluence | Atlassian'
                    }),
                    closeIconLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.CloseModalButtonMobileLabel',
                        defaultMessage: 'Close modal'
                    })
                })
            ]
        })
    });
};
$64d774ca96291cd1$var$AISection.displayName = 'AISection';
var $64d774ca96291cd1$export$2e2bcd8739ae039 = $64d774ca96291cd1$var$AISection;

});
parcelRegister("irfTW", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return $1f8cf09c15c408d6$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bNzAT = parcelRequire("bNzAT");

var $l2rHD = parcelRequire("l2rHD");

var $32y9L = parcelRequire("32y9L");
const $1f8cf09c15c408d6$var$aiParentStyles = null;
const $1f8cf09c15c408d6$var$videoStyles = null;
const $1f8cf09c15c408d6$var$imageStyles = null;
const $1f8cf09c15c408d6$var$footerStyles = null;
const $1f8cf09c15c408d6$export$7ae07b56aa46260e = ({ theme: theme, title: title, buttonPosition: buttonPosition, button: button, videoLink: videoLink, includeFooter: includeFooter, showBurst: showBurst, videoContainerClassName: videoContainerClassName, videoClassName: videoClassName, burstClassName1: burstClassName1, burstClassName2: burstClassName2 })=>{
    const intl = (0, $8e22h.default)();
    const aiSectionStyles = null;
    const buttonSectionStyles = null;
    const titleStyles = null;
    const burstStyles1 = null;
    const burstStyles2 = null;
    const videoContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _bfhk1blq _syazu67f _4t3i1wug _1reo15vq _18m915vq _ca0q1f4h _u5f39by0 _n3tdidpf _19bv9by0 _1o9zidpf _1bsb1osq _kqswh2mm _9o8yglyw _tl281ylp _axwiidpf _1hwcidpf _sp8tidpf"
                ]),
                style: {
                    "--_1yyr69s": (0, $6ZVlx.default)(theme === 'light' ? '#CFE1FD' : '#1868DB')
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _4t3i1uc6 _1bsb53f4 _1e029by0 _liwcglyw",
                            burstClassName1
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2rHD.Burst), {})
                    }),
                    theme === 'light' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32y9L.IntelligenceLight), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32y9L.IntelligenceDark), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_syaz83dj _y3gn1h6o _1iqs1cme _ect41vau _1wybckbl _zg8l4jg8 _k48p1fw0 _vwz4ckbl _85i5zwfg _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        style: {
                            "--_e9aqa9": (0, $6ZVlx.default)(theme === 'light' ? '#101214' : '#FFF'),
                            "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                            buttonPosition !== 'bottom' ? '' : 'hide'
                        ]),
                        children: button
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _4t3i7ynd _1bsb8ved _u7cogktf _rjxp9by0 _liwcglyw",
                            burstClassName2
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2rHD.Burst), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1wug _liwcglyw",
                            videoContainerClassName
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                            playsInline: true,
                            muted: true,
                            preload: "auto",
                            autoPlay: true,
                            loop: true,
                            className: (0, $2jatx.default)([
                                "_p12f1uof _4t3i1wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _liwcglyw",
                                videoClassName
                            ]),
                            children: [
                                intl.formatMessage({
                                    id: 'ConfluenceSoftwarePage.v4.AISection.imgAlt',
                                    defaultMessage: 'demo of AI integration'
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                                    src: videoLink,
                                    type: `video/webm`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp",
                        loading: "lazy",
                        alt: intl.formatMessage({
                            id: 'ConfluenceSoftwarePage.v4.AISection.imgAlt',
                            defaultMessage: 'demo of AI integration'
                        }),
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _4t3i1wug _ca0q7vkz _u5f310yn _n3tdidpf _19bv10yn _je3oglyw"
                        ])
                    })
                ]
            }),
            includeFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp",
                alt: "",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1pby1mrw _1pfh1n1a"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                    buttonPosition === 'bottom' ? '' : 'hide'
                ]),
                children: button
            })
        ]
    });
};

});
parcelRegister("l2rHD", function(module, exports) {
$parcel$export(module.exports, "Burst", function () { return $8247e2fa7497915d$export$a3f4e2574d5726c7; });

var $7VQPk = parcelRequire("7VQPk");
const $8247e2fa7497915d$export$a3f4e2574d5726c7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 86 85",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.7007 14.1674C34.894 6.10495 35.5846 12.4188 38.9551 18.1907C39.4398 15.5504 40.3978 19.8405 39.0651 18.4315C39.0463 19.1506 39.7286 22.1508 40.4308 20.9456C39.8016 21.4048 42.4581 30.0808 43.3518 24.7504C43.2753 24.6369 42.3825 25.0337 42.572 24.7366C43.69 22.5286 40.8513 17.8368 40.6978 14.1628L40.7007 14.1674Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.1165 33.3455C24.3704 34.0377 29.1781 37.8998 29.1178 35.3451C28.2937 34.5933 28.8737 34.0231 27.8473 34.6824C26.7515 28.5866 2.84954 20.7621 21.0405 31.5593C20.3668 29.885 21.5849 30.7022 21.9766 31.5345C20.0488 31.4834 24.2398 34.3884 23.8836 32.8848C24.2851 32.952 24.5516 33.3213 24.1165 33.3455Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.7083 51.6375C16.3508 51.9805 19.0481 50.6754 19.9635 50.0653C18.1731 49.685 19.6559 49.1297 20.5037 49.3266C19.6722 50.7596 22.5761 49.4556 23.151 48.8563C22.762 48.955 22.6178 48.4717 23.2188 48.3C23.9493 50.3058 31.4246 44.9641 26.5584 46.0775C25.0032 45.9635 19.65 47.7249 15.9357 48.32C15.2425 49.7063 13.9577 50.3323 12.381 50.6625C10.0879 53.4867 15.1171 53.1473 15.7008 51.6357L15.7083 51.6375Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.4623 56.5432C35.0962 56.2418 34.8744 57.0798 34.2236 57.1085C34.1841 57.2423 35.0696 57.6668 34.7174 57.7106C32.2276 59.1126 28.1044 64.5844 27.5687 68.8705C25.031 75.2029 31.6172 68.442 32.037 64.697C30.4251 65.5635 31.2001 64.1846 31.9792 63.7808C32.2658 65.4111 33.6465 62.5457 33.6996 61.7154C33.4636 62.0412 33.0481 61.7639 33.397 61.2462C34.0038 62.5309 37.7314 55.8562 35.4623 56.5432Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.5445 61.1109C47.7465 60.4073 46.1495 54.4473 44.6895 56.5385C44.8557 57.5678 44.2278 57.7689 45.3235 57.8257C44.3119 61.518 47.5357 67.6249 49.5384 71.9517C54.4828 75.7229 48.9857 62.4978 48.7485 65.2683C46.8849 64.155 50.374 63.7888 47.5491 61.108L47.5445 61.1109Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M68.081 60.87C67.506 60.7298 61.702 54.6915 62.4175 57.1311C60.2478 57.0943 63.0913 55.0365 59.2985 54.1301C59.1214 53.4163 54.7623 49.0521 54.539 51.5953C55.1987 52.4036 54.7538 52.8906 55.7259 52.3933C54.6288 53.6044 56.6163 53.3357 56.7169 53.4987C56.1274 54.7824 58.4929 54.5953 57.5662 55.0517C58.5404 57.473 68.5615 65.6671 68.0735 60.8682L68.081 60.87Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.1525 41.2299C71.1084 40.0993 67.3911 41.0436 65.8157 41.0322C67.1942 40.1104 64.0113 40.0045 63.2287 40.2882C63.622 40.3735 63.5412 40.8672 62.9225 40.7604C63.8553 39.6892 56.2426 38.9673 57.7848 40.7679C57.6537 41.2218 58.5161 41.0882 58.807 41.6739C58.9428 41.6544 58.9752 40.6761 59.162 40.9788C58.9268 42.5968 60.4305 41.2633 60.6023 41.3438C60.8304 42.7336 62.6879 41.2653 62.174 42.1614C64.1349 43.7549 77.7773 44.5296 74.1583 41.2392L74.1525 41.2299Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.2396 18.8011C61.3001 20.1721 59.3546 23.4762 58.2337 24.5863C58.5467 22.9589 56.2378 25.1432 55.8882 25.8992C56.2222 25.6802 56.5164 26.0838 56.0088 26.4486C55.9014 25.0357 50.0371 29.936 52.4026 30.1027C52.6359 30.5118 53.14 29.8083 53.7629 30.0155C53.8458 29.9 53.1705 29.1913 53.5169 29.2734C54.5039 30.5806 54.6084 28.5738 54.7885 28.5012C55.9381 29.3221 56.1975 26.9624 56.474 27.9622C59.1498 27.455 68.9328 18.9586 64.2414 18.7935L64.2396 18.8011Z",
                fill: "#111213"
            })
        ]
    });
};

});

parcelRegister("32y9L", function(module, exports) {
$parcel$export(module.exports, "IntelligenceDark", function () { return $e2d342c47f46899a$export$6c136ee6aa49536d; });
$parcel$export(module.exports, "IntelligenceLight", function () { return $e2d342c47f46899a$export$28c56d9c47eae24c; });

var $7VQPk = parcelRequire("7VQPk");
const $e2d342c47f46899a$export$6c136ee6aa49536d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $e2d342c47f46899a$export$28c56d9c47eae24c = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M50.5501 27.4199H41.6001V32.4199H50.5501V27.4199Z",
                    fill: "url(#paint0_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32.4253 9.29492H27.4253V18.2449H32.4253V9.29492Z",
                    fill: "url(#paint1_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M18.2503 27.4199H9.30029V32.4199H18.2503V27.4199Z",
                    fill: "url(#paint2_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32.4253 41.595H27.4253V50.545H32.4253V41.595Z",
                    fill: "url(#paint3_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M37.8796 34.2856L34.291 37.8741L47.5051 51.0882L51.0936 47.4996L37.8796 34.2856Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.5052 8.74824L34.2935 21.9646L37.8827 25.5525L51.0944 12.3362L47.5052 8.74824Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M12.3395 8.7481L8.75098 12.3367L21.965 25.5507L25.5536 21.9622L12.3395 8.7481Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M21.9618 34.2762L8.75 47.4926L12.3392 51.0805L25.5509 37.8641L21.9618 34.2762Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_4426_97000",
                            x1: "41.6001",
                            y1: "29.9199",
                            x2: "50.5501",
                            y2: "29.9199",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_4426_97000",
                            x1: "29.9253",
                            y1: "18.2449",
                            x2: "29.9253",
                            y2: "9.29492",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_4426_97000",
                            x1: "18.2503",
                            y1: "-0.0800891",
                            x2: "9.30029",
                            y2: "-0.0800891",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_4426_97000",
                            x1: "29.9253",
                            y1: "41.595",
                            x2: "29.9253",
                            y2: "50.545",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("6YfJw", function(module, exports) {
$parcel$export(module.exports, "YoutubeModal", function () { return $86692670f5e6bd21$export$7283d5171aeba9eb; });

var $7VQPk = parcelRequire("7VQPk");

var $jOK0R = parcelRequire("jOK0R");
const $86692670f5e6bd21$export$7283d5171aeba9eb = ({ isOpen: isOpen, closeModal: closeModal, src: src, title: title, closeIconLabel: closeIconLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jOK0R.Modal), {
        isOpen: isOpen,
        closeModal: closeModal,
        closeIconLabel: closeIconLabel,
        content: (height)=>/*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                style: {
                    verticalAlign: 'bottom'
                },
                width: '100%',
                height: height,
                src: src,
                title: title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowFullScreen: true,
                "data-gtm-yt-inspected-12": "true"
            })
    });
};

});
parcelRegister("jOK0R", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return $e3e7cd9c1ba914e9$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $3RaC6 = parcelRequire("3RaC6");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");
var $ixnNi = parcelRequire("ixnNi");
var $7M4vT = parcelRequire("7M4vT");
const $e3e7cd9c1ba914e9$var$modalContentStyles = null;
const $e3e7cd9c1ba914e9$var$closeModalStyles = null;
const $e3e7cd9c1ba914e9$var$DESKTOP_MODAL_SIZE = {
    width: 'large',
    // atlaskit modal starts ignoring the width at smaller sizes
    height: '540' // atlaskit modal starts setting height to 100% at smaller sizes
};
const $e3e7cd9c1ba914e9$var$MOBILE_MODAL_SIZE = {
    width: '1024px',
    height: '576'
};
const $e3e7cd9c1ba914e9$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, closeModal: closeModal, content: content, closeIconLabel: closeIconLabel, isContentModal: isContentModal })=>{
    const intl = (0, $8e22h.default)();
    const getModalSize = ()=>{
        if (window.innerWidth >= 1024) return $e3e7cd9c1ba914e9$var$MOBILE_MODAL_SIZE;
        return $e3e7cd9c1ba914e9$var$DESKTOP_MODAL_SIZE;
    };
    const [modalSize, setModalSize] = (0, $1oC0p.useState)(getModalSize());
    (0, $1oC0p.useEffect)(()=>{
        const updateModalSize = ()=>{
            setModalSize(getModalSize());
        };
        window.addEventListener('resize', updateModalSize);
        return ()=>window.removeEventListener('resize', updateModalSize);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7M4vT.default), {
        children: isOpen && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5kbMC.default), {
            onClose: closeModal,
            width: modalSize.width,
            height: modalSize.height,
            children: [
                window.innerWidth < 480 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ixnNi.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsb1osq _1bahesu3 _jq8g1tcg"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                            appearance: "subtle-link",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                label: closeIconLabel ?? intl.formatMessage({
                                    id: 'Modal.closeIconLabel',
                                    defaultMessage: 'close modal'
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1bsb1osq _kqswh2mm _8hk7glyw _19aezwfg _i09y7vkz _1m61zwfg _8sf87vkz _12hx1wug _jdwsyly2 _z8tz1h6o _1wrf1wug _1ov51wug _9ry81wug _puii1wug _1lzu1wug _9ep71osq _skrarbzz _1c221r31 _72u08stv _17ignqa1 _e133oelr _gqi51r31 _1jvzglyw _1y27nqa1 _3njzidpf _1qbr1wug _mw5fidpf _n9dy1wug _1qmd1e5h _iml01ns9 _1hbcidpf _12evidpf _1f2i1crf _n1p2idpf _1oq91bqd _mpw4bfng _1kb4viql _1nfb10nf _pvcxidpf _1a76dlk8 _1uxeyn4p _d09fzz36 _tyl97vkz _wjni1wto _nggt1k7u _onli1tcg _1el9stnw _u7yn1lpd _14g8kfja _4wwiu67f _1ogfglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: isContentModal ? 'content-modal' : '',
                            children: content(getModalSize().height)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: "close-modal-button",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                                appearance: "subtle-link",
                                onClick: closeModal,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                    label: closeIconLabel ?? intl.formatMessage({
                                        id: 'Modal.closeIconLabel',
                                        defaultMessage: 'close modal'
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("ixnNi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d7edc4155f416dec$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8P02U = parcelRequire("8P02U");

var $8WISV = parcelRequire("8WISV");

var $dYPjn = parcelRequire("dYPjn");
var $d7edc4155f416dec$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d7edc4155f416dec$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $dYPjn.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $d7edc4155f416dec$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $d7edc4155f416dec$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8WISV.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $d7edc4155f416dec$var$styles.titleContainer
    }, children)) : children);
};
var $d7edc4155f416dec$export$2e2bcd8739ae039 = $d7edc4155f416dec$var$ModalHeader;

});
parcelRegister("8P02U", function(module, exports) {
$parcel$export(module.exports, "Flex", function () { return $66c31f411e535770$export$f51f4c4ede09e011; });
/* flex.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $66c31f411e535770$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $66c31f411e535770$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $66c31f411e535770$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $66c31f411e535770$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $66c31f411e535770$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $66c31f411e535770$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $66c31f411e535770$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $66c31f411e535770$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $66c31f411e535770$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $gnQ3X.default)(_ref, $66c31f411e535770$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, ariaAttributes, {
        role: role,
        className: (0, $2jatx.default)([
            $66c31f411e535770$var$styles.root,
            gap && $66c31f411e535770$var$columnGapMap[gap],
            columnGap && $66c31f411e535770$var$columnGapMap[columnGap],
            gap && $66c31f411e535770$var$rowGapMap[gap],
            rowGap && $66c31f411e535770$var$rowGapMap[rowGap],
            alignItems && $66c31f411e535770$var$alignItemsMap[alignItems],
            direction && $66c31f411e535770$var$flexDirectionMap[direction],
            justifyContent && $66c31f411e535770$var$justifyContentMap[justifyContent],
            wrap && $66c31f411e535770$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$66c31f411e535770$export$f51f4c4ede09e011.displayName = 'Flex';

});

parcelRegister("8WISV", function(module, exports) {
$parcel$export(module.exports, "CloseButton", function () { return $68368eb07ba4b07f$export$de65de8213222d10; });

var $1oC0p = parcelRequire("1oC0p");

var $cKNbK = parcelRequire("cKNbK");

var $5gEzD = parcelRequire("5gEzD");
var $68368eb07ba4b07f$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cKNbK.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5gEzD))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});
parcelRegister("cKNbK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $948fefbcdac869d9$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $1zpHv = parcelRequire("1zpHv");

var $huaF6 = parcelRequire("huaF6");

var $ckHGa = parcelRequire("ckHGa");

var $3aj1x = parcelRequire("3aj1x");

var $eEgkm = parcelRequire("eEgkm");

var $4mOtV = parcelRequire("4mOtV");
var $948fefbcdac869d9$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $948fefbcdac869d9$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $948fefbcdac869d9$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $948fefbcdac869d9$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $948fefbcdac869d9$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3aj1x.default), (0, $c9bqK.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eEgkm.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4mOtV.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $huaF6.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3aj1x.default), (0, $c9bqK.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $1zpHv.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eEgkm.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4mOtV.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), null, label)));
    });
}));
$948fefbcdac869d9$var$IconButton.displayName = 'IconButton';
var $948fefbcdac869d9$export$2e2bcd8739ae039 = $948fefbcdac869d9$var$IconButton;

});
parcelRegister("huaF6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbad8245ea9d1ed4$export$2e2bcd8739ae039; });
/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $iIKkf = parcelRequire("iIKkf");

var $dV9un = parcelRequire("dV9un");

var $kxIua = parcelRequire("kxIua");

var $942DS = parcelRequire("942DS");

var $2VaUS = parcelRequire("2VaUS");

var $dUP6e = parcelRequire("dUP6e");

var $iAIri = parcelRequire("iAIri");

var $6ur0l = parcelRequire("6ur0l");

var $lFMh3 = parcelRequire("lFMh3");

var $iJAOx = parcelRequire("iJAOx");

var $agtVC = parcelRequire("agtVC");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8O6sf = parcelRequire("8O6sf");

var $hbilF = parcelRequire("hbilF");

var $3Cc2B = parcelRequire("3Cc2B");

var $9Ozog = parcelRequire("9Ozog");

var $bnftV = parcelRequire("bnftV");

var $kp4DZ = parcelRequire("kp4DZ");
function $cbad8245ea9d1ed4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbad8245ea9d1ed4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbad8245ea9d1ed4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbad8245ea9d1ed4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbad8245ea9d1ed4$var$tooltipZIndex = (0, $agtVC.layers).tooltip();
var $cbad8245ea9d1ed4$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.2.1"
};
// Inverts motion direction
var $cbad8245ea9d1ed4$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $cbad8245ea9d1ed4$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $cbad8245ea9d1ed4$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $cbad8245ea9d1ed4$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $kp4DZ.default) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $dV9un.default) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $dV9un.default) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $iIKkf.usePlatformLeafSyntheticEventHandler)($cbad8245ea9d1ed4$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $cbad8245ea9d1ed4$var$analyticsAttributes));
    var onHideHandler = (0, $iIKkf.usePlatformLeafSyntheticEventHandler)($cbad8245ea9d1ed4$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $cbad8245ea9d1ed4$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $942DS.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $942DS.default)(onShowHandler);
    var onHideHandlerStable = (0, $942DS.default)(onHideHandler);
    var delayStable = (0, $942DS.default)(delay);
    var canAppearStable = (0, $942DS.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $942DS.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $8O6sf.register)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $1oC0p.useRef)(false);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $9Ozog.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $kxIua.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $dV9un.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($cbad8245ea9d1ed4$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $2VaUS.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $6ur0l.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $3Cc2B.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $bnftV.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $1oC0p.Fragment) : $cbad8245ea9d1ed4$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children($cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($cbad8245ea9d1ed4$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lFMh3.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $cbad8245ea9d1ed4$var$invertedDirection[$cbad8245ea9d1ed4$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dUP6e.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iAIri.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $cbad8245ea9d1ed4$export$2e2bcd8739ae039 = $cbad8245ea9d1ed4$var$Tooltip;
var $cbad8245ea9d1ed4$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iJAOx.default), {
        zIndex: $cbad8245ea9d1ed4$var$tooltipZIndex
    }, children);
};
var $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $cbad8245ea9d1ed4$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $1oC0p.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $jp38o.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $hbilF.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $dV9un.default)
    }) : content));
}

});
parcelRegister("iIKkf", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $da10455b33f295cb$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $7AHLK = parcelRequire("7AHLK");

var $faiHG = parcelRequire("faiHG");
function $da10455b33f295cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da10455b33f295cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da10455b33f295cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da10455b33f295cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da10455b33f295cb$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7AHLK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $faiHG.useTrackedRef)(analyticsData);
    var fnRef = (0, $faiHG.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $da10455b33f295cb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("kxIua", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef4965a1b7ee14de$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $hK9RD = parcelRequire("hK9RD");
function $ef4965a1b7ee14de$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $hK9RD.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("hK9RD", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $ceae6256f091d53c$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $ceae6256f091d53c$export$390330c10ff2b9a1 = 'ArrowUp';
var $ceae6256f091d53c$export$a80636c6f41931fe = 'ArrowDown';
var $ceae6256f091d53c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $ceae6256f091d53c$export$c40f9845adc73fb5 = 'ArrowRight';
var $ceae6256f091d53c$export$4af703091671bc = 'Home';
var $ceae6256f091d53c$export$e2bc30913faa5db7 = 'End';
var $ceae6256f091d53c$export$10f6869ed0a7d75b = 'Tab';
var $ceae6256f091d53c$export$8152f929a25a0ff4 = 'Enter';
var $ceae6256f091d53c$export$e51a3576c045c8d5 = 'Space';
var $ceae6256f091d53c$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("942DS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69968971e73d6005$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $69968971e73d6005$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("lFMh3", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $fc72df841a7fe791$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $6ur0l = parcelRequire("6ur0l");

var $gaoOw = parcelRequire("gaoOw");

var $Iz0N2 = parcelRequire("Iz0N2");

// Export types from PopperJS / React Popper
var $fc72df841a7fe791$var$viewportPadding = 5;
var $fc72df841a7fe791$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $fc72df841a7fe791$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $fc72df841a7fe791$var$defaultChildrenFn() {
    return null;
}
var $fc72df841a7fe791$var$defaultOffset = [
    0,
    8
];
function $fc72df841a7fe791$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $Iz0N2.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($fc72df841a7fe791$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $fc72df841a7fe791$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $fc72df841a7fe791$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $fc72df841a7fe791$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $fc72df841a7fe791$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $gaoOw.getMaxSizeModifiers)({
            viewportPadding: $fc72df841a7fe791$var$viewportPadding
        }) : [];
        return [].concat($fc72df841a7fe791$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("gaoOw", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $bc50d4073cb1a3f6$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $bc50d4073cb1a3f6$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("Iz0N2", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", function () { return $085f44c71f033a2e$export$9802f50720ab826e; });
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");


var $1oC0p = parcelRequire("1oC0p");

var $4kPMQ = parcelRequire("4kPMQ");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8mOPg = parcelRequire("8mOPg");

var $2oBVx = parcelRequire("2oBVx");

var $Din8a = parcelRequire("Din8a");

var $fa33e = parcelRequire("fa33e");

var $d4haZ = parcelRequire("d4haZ");

var $aunCi = parcelRequire("aunCi");

var $aKkpJ = parcelRequire("aKkpJ");

var $grvl6 = parcelRequire("grvl6");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $085f44c71f033a2e$var$noopStyle = {};
var $085f44c71f033a2e$var$noopSetRef = (0, $4kPMQ.default);
var $085f44c71f033a2e$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $085f44c71f033a2e$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $085f44c71f033a2e$var$noopArrowProps = {
    ref: $085f44c71f033a2e$var$noopSetRef,
    style: $085f44c71f033a2e$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $085f44c71f033a2e$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $085f44c71f033a2e$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $085f44c71f033a2e$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $aKkpJ.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $1oC0p.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $8mOPg.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $1oC0p.useState)(htmlAnchor), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $jp38o.fromLegacyPlacement)({
            legacy: (0, $d4haZ.toLegacyPlacement)(placement),
            offset: $085f44c71f033a2e$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $1oC0p.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $1oC0p.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $fa33e.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $Din8a.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $grvl6.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $2oBVx.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $085f44c71f033a2e$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $085f44c71f033a2e$var$getPlacementAxis(placement);
    (0, $aunCi.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $085f44c71f033a2e$var$noopSetRef,
        style: $085f44c71f033a2e$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $085f44c71f033a2e$var$noopUpdate,
        forceUpdate: $085f44c71f033a2e$var$noopForceUpdate,
        arrowProps: $085f44c71f033a2e$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("4kPMQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32813379fcd8b988$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $32813379fcd8b988$export$2e2bcd8739ae039() {}

});

parcelRegister("Din8a", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", function () { return $0761e4f1ce2c1d1d$export$175375e9a2b5515d; });

var $kGxSF = parcelRequire("kGxSF");
function $0761e4f1ce2c1d1d$export$175375e9a2b5515d() {
    var document = (0, $kGxSF.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});
parcelRegister("kGxSF", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $f0f202e110b0c4c3$export$f65ca476c09acec0; });
var $f0f202e110b0c4c3$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("fa33e", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", function () { return $b09a281848192ab4$export$b065aeb850c3e87f; });
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $b09a281848192ab4$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $b09a281848192ab4$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $b09a281848192ab4$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $b09a281848192ab4$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $b09a281848192ab4$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $b09a281848192ab4$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $b09a281848192ab4$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("d4haZ", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", function () { return $9838f8eed70ee314$export$e9a6fdb80170ffd; });
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $9838f8eed70ee314$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("aunCi", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", function () { return $7a2f067f02466300$export$f16d8ac7373995e1; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bhLXQ = parcelRequire("bhLXQ");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $7a2f067f02466300$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $7a2f067f02466300$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $7a2f067f02466300$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $7a2f067f02466300$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $7a2f067f02466300$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $bhLXQ.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $7a2f067f02466300$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $7a2f067f02466300$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $lFOXD.default)($7a2f067f02466300$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $7a2f067f02466300$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $bhLXQ.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("bhLXQ", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $83767cec90300e4b$export$37a5fde709c1db82; });
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $83767cec90300e4b$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("aKkpJ", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", function () { return $7d2e090e2707069b$export$941a7e8bf0b9eafd; });

var $1oC0p = parcelRequire("1oC0p");

var $fvM1S = parcelRequire("fvM1S");
function $7d2e090e2707069b$export$941a7e8bf0b9eafd() {
    return (0, $1oC0p.useContext)((0, $fvM1S.AnchorContext));
}

});
parcelRegister("fvM1S", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", function () { return $b4af01e6ae9d997c$export$8f73317645bb7b8e; });

var $1oC0p = parcelRequire("1oC0p");
var $b4af01e6ae9d997c$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("grvl6", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", function () { return $bf877a49ad993be2$export$61d36e2b682e92f7; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $brG9L = parcelRequire("brG9L");
var $bf877a49ad993be2$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $bf877a49ad993be2$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $bf877a49ad993be2$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $bf877a49ad993be2$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $bf877a49ad993be2$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $bf877a49ad993be2$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $bf877a49ad993be2$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $1oC0p.useState)($bf877a49ad993be2$var$INITIAL), _useState2 = (0, $2qaZZ.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $1oC0p.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $bf877a49ad993be2$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $brG9L.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $bf877a49ad993be2$var$isFullyOutsideViewport(anchorRect, viewport) || $bf877a49ad993be2$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $bf877a49ad993be2$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dH1HR.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $dH1HR.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("brG9L", function(module, exports) {
$parcel$export(module.exports, "readViewport", function () { return $8552eabaf70d5ef8$export$64beed533e21f72d; });
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $8552eabaf70d5ef8$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("8O6sf", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $6697ffff412e1a23$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $6697ffff412e1a23$var$registrations = new Set();
var $6697ffff412e1a23$var$cleanupEndEventListeners = null;
function $6697ffff412e1a23$var$onDragStart() {
    if ($6697ffff412e1a23$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6697ffff412e1a23$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $6697ffff412e1a23$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $6697ffff412e1a23$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6697ffff412e1a23$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6697ffff412e1a23$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6697ffff412e1a23$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6697ffff412e1a23$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6697ffff412e1a23$var$cleanupEndEventListeners = null;
    var clone = Array.from($6697ffff412e1a23$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6697ffff412e1a23$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $6697ffff412e1a23$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $6697ffff412e1a23$var$onDragStart
        }
    ]);
}
var $6697ffff412e1a23$var$cleanupStartEventListeners = null;
function $6697ffff412e1a23$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6697ffff412e1a23$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6697ffff412e1a23$var$cleanupStartEventListeners = $6697ffff412e1a23$var$bindStartEvents();
    $6697ffff412e1a23$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6697ffff412e1a23$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6697ffff412e1a23$var$registrations.delete(registration);
        if ($6697ffff412e1a23$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6697ffff412e1a23$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6697ffff412e1a23$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hbilF", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", function () { return $c821b25bd62de38c$export$d26fd3d066ede49; });
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $c821b25bd62de38c$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $c821b25bd62de38c$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $c821b25bd62de38c$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $c821b25bd62de38c$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $c821b25bd62de38c$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("3Cc2B", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $2a1e42c81d4cec35$export$2e68479e0a5d8746; });
function $2a1e42c81d4cec35$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("9Ozog", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $72543c5ab8410b67$export$57bf213be019eeb0; });

var $6ur0l = parcelRequire("6ur0l");
var $72543c5ab8410b67$var$delayId = null;
function $72543c5ab8410b67$var$clearScheduled() {
    if ($72543c5ab8410b67$var$delayId != null) {
        window.clearTimeout($72543c5ab8410b67$var$delayId);
        $72543c5ab8410b67$var$delayId = null;
    }
}
function $72543c5ab8410b67$var$scheduleTimeout(fn, delay) {
    $72543c5ab8410b67$var$clearScheduled();
    $72543c5ab8410b67$var$delayId = window.setTimeout(function() {
        $72543c5ab8410b67$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $72543c5ab8410b67$var$active = null;
function $72543c5ab8410b67$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($72543c5ab8410b67$var$active && $72543c5ab8410b67$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $72543c5ab8410b67$var$clearScheduled();
            $72543c5ab8410b67$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $72543c5ab8410b67$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $72543c5ab8410b67$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $72543c5ab8410b67$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($72543c5ab8410b67$var$active && $72543c5ab8410b67$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($72543c5ab8410b67$var$active) {
            $72543c5ab8410b67$var$clearScheduled();
            $72543c5ab8410b67$var$active.entry.hide({
                isImmediate: true
            });
            $72543c5ab8410b67$var$active.entry.done();
            $72543c5ab8410b67$var$active = null;
        }
        // this tooltip is now the active tooltip
        $72543c5ab8410b67$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $72543c5ab8410b67$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("bnftV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $847dda077daa4d06$export$2e2bcd8739ae039; });

var $fPWbo = parcelRequire("fPWbo");
function $847dda077daa4d06$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $fPWbo.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("fPWbo", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $b878c04de3cbd23a$export$6ee17796e3d70de2; });

var $kHlZ6 = parcelRequire("kHlZ6");
function $b878c04de3cbd23a$export$6ee17796e3d70de2() {
    var uid = (0, $kHlZ6.useId)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("kp4DZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eda9beac08093f96$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8Uo48 = parcelRequire("8Uo48");
var $eda9beac08093f96$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $eda9beac08093f96$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $1oC0p.createElement((0, $8Uo48.default), {
        ref: ref,
        style: style,
        className: (0, $2jatx.default)([
            $eda9beac08093f96$var$styles.base,
            truncate && $eda9beac08093f96$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$eda9beac08093f96$var$TooltipContainer.displayName = 'TooltipContainer';
var $eda9beac08093f96$export$2e2bcd8739ae039 = $eda9beac08093f96$var$TooltipContainer;

});
parcelRegister("8Uo48", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67c638a91a570cde$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9e03Q = parcelRequire("9e03Q");
var $67c638a91a570cde$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $67c638a91a570cde$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: role,
        className: (0, $2jatx.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $9e03Q.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$67c638a91a570cde$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $67c638a91a570cde$export$2e2bcd8739ae039 = $67c638a91a570cde$var$TooltipPrimitive;

});
parcelRegister("9e03Q", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $6b7577fe82b6dfb2$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6b7577fe82b6dfb2$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6b7577fe82b6dfb2$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $6b7577fe82b6dfb2$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $2jatx.default)([
                $6b7577fe82b6dfb2$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("ckHGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fa93c0832c102e4$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $8fa93c0832c102e4$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8fa93c0832c102e4$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2jatx.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$8fa93c0832c102e4$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $8fa93c0832c102e4$export$2e2bcd8739ae039 = $8fa93c0832c102e4$var$VisuallyHidden;

});

parcelRegister("3aj1x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24e10ffbf6b8e2c5$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4ZpaI = parcelRequire("4ZpaI");

var $1zpHv = parcelRequire("1zpHv");

var $9zh09 = parcelRequire("9zh09");

var $kHlZ6 = parcelRequire("kHlZ6");

var $6ur0l = parcelRequire("6ur0l");

var $b8nZ2 = parcelRequire("b8nZ2");

var $ckHGa = parcelRequire("ckHGa");

var $cjAw4 = parcelRequire("cjAw4");

var $4P0FC = parcelRequire("4P0FC");

var $83yV9 = parcelRequire("83yV9");

var $haKw5 = parcelRequire("haKw5");
var $24e10ffbf6b8e2c5$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $24e10ffbf6b8e2c5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $24e10ffbf6b8e2c5$var$LOADING_LABEL = ', Loading';
var $24e10ffbf6b8e2c5$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $24e10ffbf6b8e2c5$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $24e10ffbf6b8e2c5$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $24e10ffbf6b8e2c5$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $24e10ffbf6b8e2c5$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $24e10ffbf6b8e2c5$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $24e10ffbf6b8e2c5$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $24e10ffbf6b8e2c5$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $24e10ffbf6b8e2c5$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $24e10ffbf6b8e2c5$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $gnQ3X.default)(_ref, $24e10ffbf6b8e2c5$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $4P0FC.useSplitButtonContext)();
    var loadingLabelId = (0, $kHlZ6.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $9zh09.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $24e10ffbf6b8e2c5$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b8nZ2.Pressable), (0, $c9bqK.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $1zpHv.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4ZpaI.cx)($24e10ffbf6b8e2c5$var$styles.base, (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $24e10ffbf6b8e2c5$var$styles.baseT26Shape, isInteractive && (0, $6ur0l.fg)('platform-dst-motion-uplift-button') && $24e10ffbf6b8e2c5$var$styles.interactiveMotion, appearance === 'default' && $24e10ffbf6b8e2c5$var$defaultStyles.root, appearance === 'default' && isInteractive && $24e10ffbf6b8e2c5$var$defaultStyles.interactive, appearance === 'primary' && $24e10ffbf6b8e2c5$var$primaryStyles.root, appearance === 'primary' && isInteractive && $24e10ffbf6b8e2c5$var$primaryStyles.interactive, appearance === 'rovo' && $24e10ffbf6b8e2c5$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $24e10ffbf6b8e2c5$var$rovoStyles.interactive, appearance === 'warning' && $24e10ffbf6b8e2c5$var$warningStyles.root, appearance === 'warning' && isInteractive && $24e10ffbf6b8e2c5$var$warningStyles.interactive, appearance === 'danger' && $24e10ffbf6b8e2c5$var$dangerStyles.root, appearance === 'danger' && isInteractive && $24e10ffbf6b8e2c5$var$dangerStyles.interactive, appearance === 'discovery' && $24e10ffbf6b8e2c5$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $24e10ffbf6b8e2c5$var$discoveryStyles.interactive, appearance === 'subtle' && $24e10ffbf6b8e2c5$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $24e10ffbf6b8e2c5$var$subtleStyles.interactive, $24e10ffbf6b8e2c5$var$styles.linkDecorationUnset, isSelected && $24e10ffbf6b8e2c5$var$selectedStyles.root, isSelected && isSplitButton && $24e10ffbf6b8e2c5$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $24e10ffbf6b8e2c5$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $24e10ffbf6b8e2c5$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $24e10ffbf6b8e2c5$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $24e10ffbf6b8e2c5$var$selectedStyles.discovery, isDisabled && $24e10ffbf6b8e2c5$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $24e10ffbf6b8e2c5$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $24e10ffbf6b8e2c5$var$defaultStyles.disabled, spacing === 'compact' && $24e10ffbf6b8e2c5$var$styles.spacingCompact, spacing === 'compact' && (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $24e10ffbf6b8e2c5$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $24e10ffbf6b8e2c5$var$styles.circle, shouldFitContainer && $24e10ffbf6b8e2c5$var$styles.fullWidth, hasIconBefore && $24e10ffbf6b8e2c5$var$styles.buttonIconBefore, hasIconAfter && $24e10ffbf6b8e2c5$var$styles.buttonIconAfter, isIconButton && $24e10ffbf6b8e2c5$var$styles.iconButton, isIconButton && spacing === 'compact' && $24e10ffbf6b8e2c5$var$styles.iconButtonCompact, isLoading && $24e10ffbf6b8e2c5$var$styles.loading, isSplitButton && $24e10ffbf6b8e2c5$var$styles.splitButton, isNavigationSplitButton && $24e10ffbf6b8e2c5$var$styles.navigationSplitButton),
        isDisabled: (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($24e10ffbf6b8e2c5$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $83yV9.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cjAw4.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $24e10ffbf6b8e2c5$var$styles.loadingOverlay
        ])
    }, (0, $haKw5.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), {
        id: loadingLabelId
    }, $24e10ffbf6b8e2c5$var$LOADING_LABEL)));
});
var $24e10ffbf6b8e2c5$export$2e2bcd8739ae039 = $24e10ffbf6b8e2c5$var$ButtonBase;

});
parcelRegister("b8nZ2", function(module, exports) {
$parcel$export(module.exports, "Pressable", function () { return $81b30bb1dd2a079f$export$27c701ed9e449e99; });
/* pressable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $3sHnI = parcelRequire("3sHnI");

var $cTnMe = parcelRequire("cTnMe");

var $8ejO3 = parcelRequire("8ejO3");

var $dV9un = parcelRequire("dV9un");

var $hGQNn = parcelRequire("hGQNn");

var $bRZnf = parcelRequire("bRZnf");
var $81b30bb1dd2a079f$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $81b30bb1dd2a079f$var$_excluded2 = [
    "className"
];
var $81b30bb1dd2a079f$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $81b30bb1dd2a079f$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $dV9un.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $gnQ3X.default)(_ref, $81b30bb1dd2a079f$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $hGQNn.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $cTnMe.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $81b30bb1dd2a079f$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $bRZnf.Focusable), (0, $c9bqK.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $8ejO3.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $3sHnI.cx)($81b30bb1dd2a079f$var$styles.root, isDisabled && $81b30bb1dd2a079f$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});

});
parcelRegister("8ejO3", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $5fdefea9d9b4f44d$export$95df08bae54cb4df; });
function $5fdefea9d9b4f44d$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("bRZnf", function(module, exports) {
$parcel$export(module.exports, "Focusable", function () { return $8a44408cdc47afed$export$35a3bebf7ef2d934; });
/* focusable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $8a44408cdc47afed$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $8a44408cdc47afed$var$_excluded2 = [
    "className"
];
var $8a44408cdc47afed$var$focusRingStyles = null;
var $8a44408cdc47afed$var$insetFocusRingStyles = null;
var $8a44408cdc47afed$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $8a44408cdc47afed$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $8a44408cdc47afed$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2jatx.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});

});


parcelRegister("cjAw4", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $8f7395bfc41cdbd9$export$4b86304b2c0d7e71; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $8f7395bfc41cdbd9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("4P0FC", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", function () { return $382c71ee55316e65$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");

var $cjAw4 = parcelRequire("cjAw4");
var $382c71ee55316e65$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)((0, $cjAw4.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("83yV9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5dd9b11b5da463fa$export$2e2bcd8739ae039; });
function $5dd9b11b5da463fa$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5dd9b11b5da463fa$var$tabKeyCode = 9;
function $5dd9b11b5da463fa$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5dd9b11b5da463fa$var$tabKeyCode) return;
    $5dd9b11b5da463fa$var$abort(event);
}
function $5dd9b11b5da463fa$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5dd9b11b5da463fa$var$abort,
        onMouseUpCapture: $5dd9b11b5da463fa$var$abort,
        onKeyDownCapture: $5dd9b11b5da463fa$var$onKey,
        onKeyUpCapture: $5dd9b11b5da463fa$var$onKey,
        onTouchStartCapture: $5dd9b11b5da463fa$var$abort,
        onTouchEndCapture: $5dd9b11b5da463fa$var$abort,
        onPointerDownCapture: $5dd9b11b5da463fa$var$abort,
        onPointerUpCapture: $5dd9b11b5da463fa$var$abort,
        onClickCapture: $5dd9b11b5da463fa$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5dd9b11b5da463fa$var$abort
    } : events;
}

});

parcelRegister("haKw5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c80774114be1b658$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $hgEXN = parcelRequire("hgEXN");
function $c80774114be1b658$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c80774114be1b658$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c80774114be1b658$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hgEXN.default), {
        size: $c80774114be1b658$var$getIconSpacing(spacing),
        appearance: $c80774114be1b658$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("hgEXN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c923b4cd89681cbd$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $hGQNn = parcelRequire("hGQNn");

var $houd6 = parcelRequire("houd6");
/**
 * Returns the appropriate circle stroke color.
 */ function $c923b4cd89681cbd$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $c923b4cd89681cbd$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $c923b4cd89681cbd$var$loadIn = null;
var $c923b4cd89681cbd$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $c923b4cd89681cbd$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $c923b4cd89681cbd$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $houd6.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $c923b4cd89681cbd$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $hGQNn.default));
    $c923b4cd89681cbd$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.wrapperStyles,
            $c923b4cd89681cbd$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.circleStyles
        ])
    })));
}));
var $c923b4cd89681cbd$export$2e2bcd8739ae039 = $c923b4cd89681cbd$var$Spinner;

});
parcelRegister("houd6", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $ca9c1cb54a98aa67$export$4e9f1640bbe7a1a8; });
var $ca9c1cb54a98aa67$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("eEgkm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aaa17769bc7d8888$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
var $aaa17769bc7d8888$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $aaa17769bc7d8888$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $aaa17769bc7d8888$var$styles.common,
            type === 'text' && $aaa17769bc7d8888$var$styles.text,
            type === 'icon' && $aaa17769bc7d8888$var$styles.icon,
            isLoading && $aaa17769bc7d8888$var$styles.fade
        ])
    }, children);
};
var $aaa17769bc7d8888$export$2e2bcd8739ae039 = $aaa17769bc7d8888$var$Content;

});

parcelRegister("4mOtV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32e06019ad32533f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
function $32e06019ad32533f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $32e06019ad32533f$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $32e06019ad32533f$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $6ur0l.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, iconProps));
};
var $32e06019ad32533f$export$2e2bcd8739ae039 = $32e06019ad32533f$var$IconRenderer;

});


parcelRegister("5gEzD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d5deb74fe887a10$var$_react = $3d5deb74fe887a10$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3d5deb74fe887a10$var$_iconNew = $3d5deb74fe887a10$var$_interopRequireDefault((parcelRequire("4lan8")));
function $3d5deb74fe887a10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d5deb74fe887a10$var$CrossIcon = (props)=>/*#__PURE__*/ $3d5deb74fe887a10$var$_react.default.createElement($3d5deb74fe887a10$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$3d5deb74fe887a10$var$CrossIcon.displayName = 'CrossIcon';
var $3d5deb74fe887a10$var$_default = module.exports.default = $3d5deb74fe887a10$var$CrossIcon;

});
parcelRegister("4lan8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", function () { return $32912b4e32c2c3a8$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $32912b4e32c2c3a8$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $32912b4e32c2c3a8$var$svgStyles = null;
var $32912b4e32c2c3a8$var$iconStyles = null;
var $32912b4e32c2c3a8$var$smallIconStyles = null;
var $32912b4e32c2c3a8$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $32912b4e32c2c3a8$var$baseHcmStyles = null;
var $32912b4e32c2c3a8$var$scaleSize = null;
var $32912b4e32c2c3a8$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $32912b4e32c2c3a8$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $32912b4e32c2c3a8$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $32912b4e32c2c3a8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $32912b4e32c2c3a8$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $32912b4e32c2c3a8$var$coreSizeSmall[spacing] : $32912b4e32c2c3a8$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$32912b4e32c2c3a8$export$2e2bcd8739ae039 = $32912b4e32c2c3a8$export$f04a61298a47a40f;

});







parcelRegister("bCAvd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61c5850de1119ed8$export$2e2bcd8739ae039; });
/* content-types-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $iXFL3 = parcelRequire("iXFL3");

var $7GVWk = parcelRequire("7GVWk");

var $7yyLA = parcelRequire("7yyLA");

var $9ckS1 = parcelRequire("9ckS1");

var $kY2rG = parcelRequire("kY2rG");

var $c8DdQ = parcelRequire("c8DdQ");

var $7zrqq = parcelRequire("7zrqq");

var $5EpoY = parcelRequire("5EpoY");

var $aHOGX = parcelRequire("aHOGX");

var $jg9LG = parcelRequire("jg9LG");

var $7VkQP = parcelRequire("7VkQP");
const $61c5850de1119ed8$var$tabStyles = null;
const $61c5850de1119ed8$var$iconTabListStyles = null;
const $61c5850de1119ed8$var$iconTabStyles = null;
const $61c5850de1119ed8$var$opacityIn = null;
const $61c5850de1119ed8$var$contentContainer = null;
const $61c5850de1119ed8$export$375e4d9f76d4c766 = ({ isConfluenceCrossflow: isConfluenceCrossflow = false })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    const tabList = [
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9ckS1.PagesIcon), {
                width: "1.5em"
            }),
            content: (0, $5EpoY.PagesContentType),
            eventProps: {
                label: 'content-type-tab-pages',
                labelEnglish: 'Pages'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c8DdQ.WhiteboardsIcon), {
                width: "1.5em"
            }),
            content: (0, $jg9LG.WhiteboardsContentType),
            eventProps: {
                label: 'content-type-tab-whiteboard',
                labelEnglish: 'Whiteboards'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7yyLA.DatabasesIcon), {
                width: "1.5em"
            }),
            content: (0, $7zrqq.DatabasesContentType),
            eventProps: {
                label: 'content-type-tab-databases',
                labelEnglish: 'Databases'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kY2rG.SpacesIcon), {
                width: "1.5em"
            }),
            content: (0, $aHOGX.SpacesContentType),
            eventProps: {
                label: 'content-type-tab-spaces',
                labelEnglish: 'Spaces'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-contentTypesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f144l _195g1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                        className: (0, $2jatx.default)([
                            "_1q51ftgi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq _1bah1yb4 _owpu1tcg _1bhl7vkz _2osn7vkz"
                        ]),
                        children: tabList.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                dataEventProps: !isConfluenceCrossflow ? {
                                    'data-product-key': 'confluence',
                                    'data-event': 'clicked',
                                    'data-event-component': 'tab',
                                    'data-event-container': 'contentTypesSection',
                                    'data-label': tab.eventProps?.label ?? 'content-type-tab',
                                    'data-label-english': tab.eventProps?.labelEnglish,
                                    'data-track-event': 'confluence-pt.content-types.tab'
                                } : undefined,
                                onClick: ()=>{
                                    if (!isConfluenceCrossflow) return;
                                    createAnalyticsEvent({
                                        eventName: 'confluence-crossflow-content-types-tab-clicked',
                                        eventType: 'ui',
                                        action: 'clicked',
                                        actionSubject: 'confluenceCrossflowTab',
                                        attributes: {
                                            reactComponent: 'ContentTypesSection',
                                            tab: tab.eventProps?.labelEnglish?.toLowerCase(),
                                            userTeamType: user.extended_profile?.team_type
                                        }
                                    }).fire();
                                },
                                className: (0, $2jatx.default)([
                                    "_2rkoyh40"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXFL3.IconTab), {
                                    icon: tab.icon,
                                    title: tab.title,
                                    lozenge: tab.lozenge
                                })
                            }, index))
                    }),
                    tabList.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _195g1wug _1q51zwfg _1tker5sb _owpu1tcg _o5kch9n0 _1bhl7vkz _xc2izwfg _j6qu12it _y44vsw2d"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)(tab.content, {
                                    index: index,
                                    isConfluenceCrossflow: isConfluenceCrossflow
                                })
                            })
                        }, index))
                ]
            })
        })
    });
};
$61c5850de1119ed8$export$375e4d9f76d4c766.displayName = 'ContentTypesSection';
var $61c5850de1119ed8$export$2e2bcd8739ae039 = $61c5850de1119ed8$export$375e4d9f76d4c766;

});
parcelRegister("iXFL3", function(module, exports) {
$parcel$export(module.exports, "IconTab", function () { return $d8474a2425643ec8$export$5fd6e91639893354; });
/* icon-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $d8474a2425643ec8$var$tabVerticalWrapper = null;
const $d8474a2425643ec8$var$tabTextWrapper = null;
const $d8474a2425643ec8$var$selectedTabStyle = null;
const $d8474a2425643ec8$var$titleStyle = null;
const $d8474a2425643ec8$var$lozengeStyle = null;
const $d8474a2425643ec8$var$underline = null;
const $d8474a2425643ec8$var$selectedUnderline = null;
const $d8474a2425643ec8$export$5fd6e91639893354 = ({ isSelected: isSelected, icon: icon, title: title, lozenge: lozenge })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _133i1crf _v736yh40 _chtu1y44 _16im7vkz _1wfq1y44 _15vtftgi _30l3u5k9 _1xjmu5k9",
                    isSelected && "_syazu5k9 _1yo9u5k9"
                ]),
                style: {
                    "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                },
                children: [
                    icon,
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1mouidpf _11cgftgi _1ywm7vkz",
                            "h4"
                        ]),
                        children: [
                            title,
                            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ahbqftgi _2rko1l7b _bfhk1bjw _syazftjs _18zr1y44 _1p1dangw _1wyb1675 _vwz41j6v _k48pbfng _s7n4nkob"
                                ]),
                                style: {
                                    "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                },
                                children: lozenge
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4t3i1y44 _2rkoyh40",
                    isSelected && "_bfhku5k9"
                ]),
                style: {
                    "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                }
            })
        ]
    });
};

});

parcelRegister("7yyLA", function(module, exports) {
$parcel$export(module.exports, "DatabasesIcon", function () { return $d8228f68cc84606d$export$4fe34b71b973310d; });

var $7VQPk = parcelRequire("7VQPk");
const $d8228f68cc84606d$export$4fe34b71b973310d = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.9465 21.5V28H16.4465V21.5H28.9465ZM28.9465 18.5V12.5H16.4465V18.5H28.9465ZM28.9465 9.5V0H0.946533V9.5H28.9465ZM0.946533 12.5V18.5H13.4465V12.5H0.946533ZM0.946533 21.5H13.4465V28H0.946533V21.5Z",
            fill: "currentColor"
        })
    });

});

parcelRegister("9ckS1", function(module, exports) {
$parcel$export(module.exports, "PagesIcon", function () { return $e4eaaa1e56221255$export$34791a62a45c026; });

var $7VQPk = parcelRequire("7VQPk");
const $e4eaaa1e56221255$export$34791a62a45c026 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 31,
        viewBox: "0 0 31 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.947 0h22v22h-22zm17 6h-12v3h12zm0 7h-12v3h12z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.947 9v16h-16v4h20V9z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("kY2rG", function(module, exports) {
$parcel$export(module.exports, "SpacesIcon", function () { return $4dc6ebf3a8febd1d$export$90df9698aa84700a; });

var $7VQPk = parcelRequire("7VQPk");
const $4dc6ebf3a8febd1d$export$90df9698aa84700a = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M15.695 0a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-15 8h8V4h-8zm0 16h8v-4h-8zm0-12h8v4h-8z",
            fill: "currentColor"
        })
    });

});

parcelRegister("c8DdQ", function(module, exports) {
$parcel$export(module.exports, "WhiteboardsIcon", function () { return $cd9d1a63bf679a68$export$5dab50d99c45ffad; });

var $7VQPk = parcelRequire("7VQPk");
const $cd9d1a63bf679a68$export$5dab50d99c45ffad = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 27,
        height: 27,
        viewBox: "0 0 27 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.24 5.793c.292-.874 1.284-1.802 2.57-2.296 1.347-.518 2.264-.305 2.602.033.19.191.194.293.194.327.002.078-.025.257-.205.56-.382.643-1.123 1.335-1.941 2.05l-.182.16c-.318.276-.648.564-.903.815a4 4 0 0 0-.47.538c-.11.154-.38.554-.375 1.095.003.32.101.65.318.937.203.268.451.42.644.508.354.16.724.188.976.195.545.014 1.292-.073 2.232-.23 2.577-.429 3.984.226 4.511.878.438.541.651 1.602-.523 3.168l2.25 1.688c1.638-2.184 1.992-4.73.46-6.624-1.252-1.549-3.43-2.211-5.978-2.026.515-.51 1.03-1.094 1.4-1.716.334-.565.62-1.272.598-2.07-.023-.842-.382-1.606-1.017-2.241C18.864.005 16.499.218 14.8.872c-1.761.677-3.581 2.093-4.228 4.032zm-6.302 14.27a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125m0-2.813a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m10.781-2.812c.494 0 .951.259 1.206.682l5.625 9.375a1.406 1.406 0 0 1-1.206 2.13h-11.25a1.406 1.406 0 0 1-1.206-2.13l5.625-9.375a1.4 1.4 0 0 1 1.206-.682m3.141 9.375-3.141-5.236-3.142 5.235z",
            fill: "currentColor"
        })
    });

});

parcelRegister("7zrqq", function(module, exports) {
$parcel$export(module.exports, "DatabasesContentType", function () { return $1c16f268fc978ca6$export$abd9e762d8d9ba66; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $1c16f268fc978ca6$export$abd9e762d8d9ba66 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/databases');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-databases',
                'data-label-english': 'Explore Databases',
                'data-track-event': 'confluence-pt.content-types.databases.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'DatabasesContentType',
                        tab: 'databases',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
    });
};

});
parcelRegister("g6LIw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::66a799ab1502bc13cc028e76ca03921b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bba2387ddd03cb94$var$_react = $bba2387ddd03cb94$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bba2387ddd03cb94$var$_baseNew = $bba2387ddd03cb94$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $bba2387ddd03cb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bba2387ddd03cb94$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $bba2387ddd03cb94$var$_react.default.createElement($bba2387ddd03cb94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$bba2387ddd03cb94$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $bba2387ddd03cb94$var$_default = module.exports.default = $bba2387ddd03cb94$var$StrokeWeightMediumIcon;

});

parcelRegister("7VkQP", function(module, exports) {
$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $5ec21e3943929bcb$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $5ec21e3943929bcb$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $5ec21e3943929bcb$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $5ec21e3943929bcb$export$954db68b244e5987; });

var $fnHPc = parcelRequire("fnHPc");
const $5ec21e3943929bcb$export$4256e39427240bad = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName',
        defaultMessage: 'Pages'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2',
        defaultMessage: 'Get everyone on the same page'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2',
        defaultMessage: 'Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader',
        defaultMessage: 'Create content with ease:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1',
        defaultMessage: 'Countless templates to get started fast'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2',
        defaultMessage: 'Realtime collaboration with live docs, or draft and publish with pages'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3',
        defaultMessage: 'AI editor to fill in the blanks'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta',
        defaultMessage: 'Try it out'
    }
});
const $5ec21e3943929bcb$export$86b5cdc1c559b81d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName',
        defaultMessage: 'Whiteboards'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title',
        defaultMessage: 'Next-gen brainstorming'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description',
        defaultMessage: 'Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader',
        defaultMessage: 'Ideate on an infinite canvas with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1',
        defaultMessage: 'Brainstorming templates'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2',
        defaultMessage: 'Diagrams and flow charts'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3',
        defaultMessage: 'Team retrospectives'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta',
        defaultMessage: 'Explore Whiteboards'
    }
});
const $5ec21e3943929bcb$export$505de7052a30846e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName',
        defaultMessage: 'Databases'
    },
    tabLozenge: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge',
        defaultMessage: 'beta'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.title',
        defaultMessage: 'A new way to stay in sync'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.description',
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader',
        defaultMessage: 'Connect and relate information with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1',
        defaultMessage: 'Dynamic fields'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2',
        defaultMessage: 'Configurable views'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3',
        defaultMessage: 'Aggregated data sources'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta',
        defaultMessage: 'Explore Databases'
    }
});
const $5ec21e3943929bcb$export$954db68b244e5987 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName',
        defaultMessage: 'Spaces'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title',
        defaultMessage: 'Find what you need'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description',
        defaultMessage: 'Organize knowledge across teams, projects, and goals with Spaces in Confluence.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader',
        defaultMessage: 'Discover relevant information with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1',
        defaultMessage: 'Structured page tree'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2',
        defaultMessage: 'Centralized access to knowledge'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3',
        defaultMessage: 'Customizable permissions'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta',
        defaultMessage: 'Explore knowledge sharing'
    }
});

});


parcelRegister("5EpoY", function(module, exports) {
$parcel$export(module.exports, "PagesContentType", function () { return $975cd41fcec23a6d$export$3914470415d96f5f; });
/* pages-content-type.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $975cd41fcec23a6d$var$hideMobile = null;
const $975cd41fcec23a6d$export$3914470415d96f5f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: intl.locale === 'en' ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1mjbglyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                href: 'https://www.atlassian.com/confluence-sandbox-editor',
                text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentCta),
                type: 'primary',
                dataEventProps: !isConfluenceCrossflow ? {
                    'data-product-key': 'confluence',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'contentTypesSection',
                    'data-event': 'clicked',
                    'data-label': 'try-it-out',
                    'data-label-english': 'Try it out',
                    'data-track-event': 'confluence-pt.content-types.pages.cta'
                } : undefined,
                onClick: ()=>{
                    if (!isConfluenceCrossflow) return;
                    createAnalyticsEvent({
                        eventName: 'confluence-crossflow-tab-cta-clicked',
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'linkButton',
                        actionSubjectId: 'confluenceCrossFlowHeroSection',
                        attributes: {
                            reactComponent: 'PagesContentType',
                            tab: 'pages',
                            userTeamType: user.extended_profile?.team_type
                        }
                    }).fire();
                }
            })
        }) : undefined,
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
    });
};

});

parcelRegister("aHOGX", function(module, exports) {
$parcel$export(module.exports, "SpacesContentType", function () { return $03dc098a3df1d535$export$31e6bce70211a7b2; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $03dc098a3df1d535$export$31e6bce70211a7b2 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/use-cases/knowledge-management-software');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-knowledge-sharing',
                'data-label-english': 'Explore knowledge sharing',
                'data-track-event': 'confluence-pt.content-types.spaces.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'SpacesContentType',
                        tab: 'spaces',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Spaces_Preview.webp"
    });
};

});

parcelRegister("jg9LG", function(module, exports) {
$parcel$export(module.exports, "WhiteboardsContentType", function () { return $b9c539ed2bf6758b$export$163a1257b16e076f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $b9c539ed2bf6758b$export$163a1257b16e076f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/whiteboards');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-whiteboards',
                'data-label-english': 'Explore Whiteboards',
                'data-track-event': 'confluence-pt.content-types.whiteboards.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'WhiteboardsContentType',
                        tab: 'whiteboards',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
    });
};

});


parcelRegister("heBZG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af1005f560ec61fd$export$2e2bcd8739ae039; });
/* cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $aq7HV = parcelRequire("aq7HV");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $jQ0cd = parcelRequire("jQ0cd");
const $af1005f560ec61fd$var$sectionContainer = null;
const $af1005f560ec61fd$var$contentContainer = null;
const $af1005f560ec61fd$var$backgroundBlue = null;
const $af1005f560ec61fd$var$backgroundYellow = null;
const $af1005f560ec61fd$var$textSection = null;
const $af1005f560ec61fd$var$headingText = null;
const $af1005f560ec61fd$var$subText = null;
const $af1005f560ec61fd$var$graphicSection = null;
const $af1005f560ec61fd$var$replacesStyle = null;
const $af1005f560ec61fd$var$CtaSection = ()=>{
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-ctaSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1rd8 _1tke1784 _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz1ak8 _bfhkkizl _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p5cbm"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz116y _bfhkdoyu _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p8ehm"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1txw _2lx2vrvc _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgvbgk _y4tivbgk _1q5116xz _85i516xz _zulpzwfg _na0i1bp4 _2osn1wqb _144t1k7u _xc2i1fqw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_gu181h6o _8fz61c5i"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _uqyg1k8s"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.header",
                                        defaultMessage: "Ditch your old docs, collaborate effortlessly with Confluence"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1pfhoqnp _6rth1k8s _p12f1sxm _syaz12cp _1fkk1wug _8fz61sum"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.subtext",
                                        defaultMessage: "Confluence is your connected workspace, designed for collaboration and built to last"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'ctaSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                        href: signupLink,
                                        variant: "primary",
                                        color: "yellow",
                                        size: "large",
                                        onClick: openCrossFlow,
                                        dataEventProps: {
                                            'data-product-key': 'confluence',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'ctaSection',
                                            'data-label': 'cta-get-confluence-free',
                                            'data-label-english': 'Get Confluence free',
                                            'data-track-event': 'confluence-pt.cta.get-confluence-free'
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "ConfluenceSoftwarePage.v4.heroCTA",
                                            defaultMessage: "Get Confluence free"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _16jlidpf _1o9zidpf _i0dlhwvj"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'ctaSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aq7HV.AnimatedButtonArrows), {
                                        product: "confluence",
                                        href: signupLink,
                                        onClick: openCrossFlow,
                                        color: "#fff"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluencelp-replaces.webp",
                                    alt: "",
                                    role: "presentation",
                                    className: (0, $2jatx.default)([
                                        "_1pfh8pqr _tzy4q80t _1o2w1lyw _lcxvglyw"
                                    ])
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$af1005f560ec61fd$var$CtaSection.displayName = 'CtaSection';
var $af1005f560ec61fd$export$2e2bcd8739ae039 = $af1005f560ec61fd$var$CtaSection;

});
parcelRegister("aq7HV", function(module, exports) {
$parcel$export(module.exports, "AnimatedButtonArrows", function () { return $0cb23f027c4819c3$export$554aaec702debd9a; });
/* animated-button-arrows.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $5uYpV = parcelRequire("5uYpV");
const $0cb23f027c4819c3$var$animatedContainer = null;
const $0cb23f027c4819c3$var$arrowStyle = null;
const $0cb23f027c4819c3$var$arrowsContainer = null;
const $0cb23f027c4819c3$export$8941bb92081bfaa5 = (props)=>{
    const arrowInlineStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "52",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _5sag9cwz _tip8kb7n _1o51eoah",
            "_1e021mv2 _rjxp1afg _152tl7rb _t9ecwv2z",
            props.animate && "_j7hqgx4m"
        ]),
        style: {
            color: props.color ? props.color : 'currentColor',
            visibility: props.animate ? 'visible' : 'hidden',
            "--_11zanbc": (0, $6ZVlx.default)(props.left),
            "--_c7a5uq": (0, $6ZVlx.default)(props.right),
            "--_kmwll6": (0, $6ZVlx.default)(props.top),
            "--_l8fg41": (0, $6ZVlx.default)(props.rotate ?? 0, "deg"),
            "--_76lb24": (0, $6ZVlx.default)(props.translateX ?? '0%'),
            "--_s0bevx": (0, $6ZVlx.default)(props.translateY ?? '0%')
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $0cb23f027c4819c3$var$buttonStyle = null;
const $0cb23f027c4819c3$var$arrowInAnimation = null;
const $0cb23f027c4819c3$export$554aaec702debd9a = ({ product: product, href: href, color: color, distanceMultiplier: distanceMultiplier = 2, useInViewOptions: useInViewOptions, onClick: onClick })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 0.5,
        ...useInViewOptions
    });
    const translateX = `-${distanceMultiplier * 100}%`;
    const translateY = `-${distanceMultiplier * 50}%`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1reoewfl _18m9ewfl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 26.4,
                        top: "-15%",
                        left: "-77px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 2.4,
                        top: "40%",
                        left: "-79px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -31.8,
                        top: "92%",
                        left: "-78px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                ref: scrollRef,
                href: href,
                onClick: onClick,
                "aria-label": product,
                className: (0, $2jatx.default)([
                    "_1e0c116y _bfhku67f _2rkogktf _t9ec16ji _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1l9u7vkz _w8l51gw8 _17521gw8 _rulp1yij _19ek1yij _1dbzuehs"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
                    brand: product,
                    type: "mark",
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 137.7,
                        top: "-11%",
                        right: "-70px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 169.6,
                        top: "37%",
                        right: "-84px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -171.6,
                        top: "87%",
                        right: "-75px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("2Jr3C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b95c3b42d3906cd4$export$2e2bcd8739ae039; });
/* feel-supported-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $1nOTC = parcelRequire("1nOTC");

var $f2Lca = parcelRequire("f2Lca");

var $4eAXW = parcelRequire("4eAXW");

var $b5WBX = parcelRequire("b5WBX");

var $6fSQu = parcelRequire("6fSQu");

var $jQ0cd = parcelRequire("jQ0cd");

var $6W938 = parcelRequire("6W938");
const $b95c3b42d3906cd4$var$feelSupportedSectionStyles = null;
const $b95c3b42d3906cd4$var$feelSupportedSectionHeaderStyles = null;
const $b95c3b42d3906cd4$var$infoCardContainerStyles = null;
const $b95c3b42d3906cd4$var$cardGroup = null;
const $b95c3b42d3906cd4$var$FeelSupportedSection = ()=>{
    const intl = (0, $8e22h.default)();
    const infoCards1 = [
        {
            id: 'atlassianCommunity',
            Icon: (0, $f2Lca.GroupsIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).atlassianCommunityInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).atlassianCommunityInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.atlassianCommunityInfoCardCallToActionText
            // ),
            callToActionUrl: 'https://community.atlassian.com/t5/Confluence/ct-p/confluence',
            eventProps: {
                label: 'atlassian-community',
                labelEnglish: 'Atlassian Community'
            }
        },
        {
            id: 'useCases',
            Icon: (0, $4eAXW.OfficeBuildingIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).useCasesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).useCasesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.useCasesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/use-cases'),
            eventProps: {
                label: 'use-cases',
                labelEnglish: 'Use cases'
            }
        }
    ];
    const infoCards2 = [
        {
            id: 'videoWalkthroughs',
            Icon: (0, $b5WBX.PlayIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).videoWalkthroughsInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).videoWalkthroughsInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.videoWalkthroughsInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/demo'),
            eventProps: {
                label: 'video-walkthroughs',
                labelEnglish: 'Video walkthroughs'
            }
        },
        {
            id: 'productGuides',
            Icon: (0, $1nOTC.DocumentsIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).productGuidesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).productGuidesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.productGuidesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/resources/guides'),
            eventProps: {
                label: 'product-guides',
                labelEnglish: 'Product guides'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-feelSupportedSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1pfh1ylp _6rthzwfg _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_6rth1ex1 _gu181h6o"
                    ]),
                    children: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).feelSupportSectionHeader)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _19pkidpf _2hwx1wug _otyridpf _18u01wug _1n261g80 _zulp1tcg _p12f11vz _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards1.map(({ eventProps: eventProps, id: id, ...infoCardProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6fSQu.InfoCard), {
                                    ...infoCardProps,
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'card',
                                        'data-event-container': 'additionalResourcesSection',
                                        'data-label': eventProps?.label,
                                        'data-label-english': eventProps?.labelEnglish
                                    }
                                }, id))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards2.map(({ eventProps: eventProps, id: id, ...infoCardProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6fSQu.InfoCard), {
                                    ...infoCardProps,
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'card',
                                        'data-event-container': 'additionalResourcesSection',
                                        'data-label': eventProps?.label,
                                        'data-label-english': eventProps?.labelEnglish
                                    }
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
};
$b95c3b42d3906cd4$var$FeelSupportedSection.displayName = 'FeelSupportedSection';
var $b95c3b42d3906cd4$export$2e2bcd8739ae039 = $b95c3b42d3906cd4$var$FeelSupportedSection;

});
parcelRegister("1nOTC", function(module, exports) {
$parcel$export(module.exports, "DocumentsIcon", function () { return $846a54b40753b380$export$f4d1f69b1f255ce3; });

var $7VQPk = parcelRequire("7VQPk");
const $846a54b40753b380$export$f4d1f69b1f255ce3 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Documents",
                clipPath: "url(#clip0_5565_6299)",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Vector",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.9993 8.5H20.9993L29.9993 17.5V33.5H10.9993V8.5ZM18.9993 19.5V11.5L26.9993 19.5H18.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M32.9991 18.5V36.5H16.9991V40.5H36.9991V18.5H32.9991Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6299",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("f2Lca", function(module, exports) {
$parcel$export(module.exports, "GroupsIcon", function () { return $8ce456a773f2e7b4$export$6b0e36037a267557; });

var $7VQPk = parcelRequire("7VQPk");
const $8ce456a773f2e7b4$export$6b0e36037a267557 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Brand Icons/Groups",
            clipPath: "url(#clip0_6876_13409)",
            filter: "url(#filter0_d_6876_13409)",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.4463 31.5C17.4463 27.634 20.5803 24.5 24.4463 24.5C28.3123 24.5 31.4463 27.634 31.4463 31.5V40.5H17.4463V31.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M30.4463 15.5C30.4463 18.8137 27.76 21.5 24.4463 21.5C21.1326 21.5 18.4463 18.8137 18.4463 15.5C18.4463 12.1863 21.1326 9.5 24.4463 9.5C27.76 9.5 30.4463 12.1863 30.4463 15.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.2581 21.3824C31.6422 21.4595 32.0395 21.5 32.4463 21.5C35.76 21.5 38.4463 18.8137 38.4463 15.5C38.4463 12.1863 35.76 9.5 32.4463 9.5C32.0395 9.5 31.6422 9.54048 31.2581 9.61764C32.6216 11.1952 33.4463 13.2513 33.4463 15.5C33.4463 17.7487 32.6216 19.8048 31.2581 21.3824Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.6345 9.61764C16.271 11.1952 15.4463 13.2513 15.4463 15.5C15.4463 17.7487 16.271 19.8048 17.6345 21.3824C17.2504 21.4595 16.8531 21.5 16.4463 21.5C13.1326 21.5 10.4463 18.8137 10.4463 15.5C10.4463 12.1863 13.1326 9.5 16.4463 9.5C16.8531 9.5 17.2504 9.54048 17.6345 9.61764Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.3049 24.5C15.5366 26.3037 14.4463 28.7745 14.4463 31.5V40.5H10.4463V29.5C10.4463 26.7386 12.6849 24.5 15.4463 24.5H17.3049Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M34.4463 40.5V31.5C34.4463 28.7745 33.356 26.3037 31.5877 24.5H33.4463C36.2077 24.5 38.4463 26.7386 38.4463 29.5V40.5H34.4463Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4eAXW", function(module, exports) {
$parcel$export(module.exports, "OfficeBuildingIcon", function () { return $a44e9e73e8ce2395$export$2a7e5122c4e1fda; });

var $7VQPk = parcelRequire("7VQPk");
const $a44e9e73e8ce2395$export$2a7e5122c4e1fda = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Office Building",
                clipPath: "url(#clip0_5565_6283)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.999 40.5V8.5H35.999V40.5H26.9995V33.5H20.9995V40.5H11.999ZM17.999 15.5H21.999V12.5H17.999V15.5ZM25.999 15.5H29.999V12.5H25.999V15.5ZM21.999 22.5H17.999V19.5H21.999V22.5ZM17.999 29.5H21.999V26.5H17.999V29.5ZM29.999 22.5H25.999V19.5H29.999V22.5ZM25.999 29.5H29.999V26.5H25.999V29.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6283",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("b5WBX", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $c98fe34d56285e32$export$a6630b90defda83f; });

var $7VQPk = parcelRequire("7VQPk");
const $c98fe34d56285e32$export$a6630b90defda83f = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_5565_6290)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.999 10.5H9.99902V38.5H37.999V10.5ZM17.0027 16C15.8981 16 15.0027 16.8954 15.0027 18C15.0027 19.1046 15.8981 20 17.0027 20C18.1073 20 19.0027 19.1046 19.0027 18C19.0027 16.8954 18.1073 16 17.0027 16ZM17.0027 29C15.8981 29 15.0027 29.8954 15.0027 31C15.0027 32.1046 15.8981 33 17.0027 33C18.1073 33 19.0027 32.1046 19.0027 31C19.0027 29.8954 18.1073 29 17.0027 29ZM15.0027 24.5C15.0027 23.3954 15.8981 22.5 17.0027 22.5C18.1073 22.5 19.0027 23.3954 19.0027 24.5C19.0027 25.6046 18.1073 26.5 17.0027 26.5C15.8981 26.5 15.0027 25.6046 15.0027 24.5ZM31.999 19.5139L21.999 19.5139V16.5139L31.999 16.5139V19.5139ZM31.999 26L21.999 26V23L31.999 23V26ZM21.999 32.5H31.999V29.5H21.999V32.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "11.999",
                y: "12.5",
                width: "24",
                height: "24",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.999 24L19.749 30.4952L19.749 17.5048L30.999 24Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6290",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6fSQu", function(module, exports) {
$parcel$export(module.exports, "InfoCard", function () { return $f03f81205745c26a$export$2a4a2d730793fc2a; });
/* info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $f03f81205745c26a$var$infoCardContainerStyles = null;
const $f03f81205745c26a$var$titleStyles = null;
const $f03f81205745c26a$var$paragraphStyles = null;
const $f03f81205745c26a$var$iconContainerStyles = null;
const $f03f81205745c26a$export$2a4a2d730793fc2a = ({ Icon: Icon, title: title, paragraph: paragraph, callToActionUrl: callToActionUrl, iconSize: iconSize = '48', dataEventProps: dataEventProps })=>{
    const isExternalHref = callToActionUrl.startsWith('https://');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: callToActionUrl,
        target: isExternalHref ? '_blank' : undefined,
        rel: isExternalHref ? 'noreferrer noopener' : undefined,
        ...dataEventProps,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bsb1178 _1tke4cy5 _1yt45gjp _2lx21bp4 _1bah1h6o _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _bfhku67f _19it14it _v564jfwv _1dbzv75q"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                        size: iconSize
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz41ul9",
                        "h4"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1tket9kd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _vwz41tcg"
                    ]),
                    children: paragraph
                })
            ]
        })
    });
};

});

parcelRegister("6W938", function(module, exports) {
$parcel$export(module.exports, "feelSupportedSectioni18n", function () { return $cfc6388c299c5d03$export$2388077e1c060dc; });

var $fnHPc = parcelRequire("fnHPc");
const $cfc6388c299c5d03$export$2388077e1c060dc = (0, $fnHPc.defineMessages)({
    feelSupportSectionHeader: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.Header',
        defaultMessage: 'Feel supported every step of the way'
    },
    atlassianCommunityInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Title',
        defaultMessage: 'Atlassian Community'
    },
    atlassianCommunityInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Paragraph',
        defaultMessage: 'Your questions, answered by our community of experts'
    },
    atlassianCommunityInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.CallToAction.Text',
        defaultMessage: 'Join now'
    },
    useCasesInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Title',
        defaultMessage: 'Use cases'
    },
    useCasesInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Paragraph',
        defaultMessage: 'How different industries & teams use Confluence'
    },
    useCasesInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.CallToAction.Text',
        defaultMessage: 'Learn more'
    },
    videoWalkthroughsInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Title',
        defaultMessage: 'Video walkthroughs'
    },
    videoWalkthroughsInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Paragraph',
        defaultMessage: 'Visual explanations for features & setup steps'
    },
    videoWalkthroughsInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.CallToAction.Text',
        defaultMessage: 'Watch now'
    },
    productGuidesInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Title',
        defaultMessage: 'User guides'
    },
    productGuidesInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Paragraph',
        defaultMessage: 'In-depth guides to help build your Confluence expertise'
    },
    productGuidesInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.CallToAction.Text',
        defaultMessage: 'Read more'
    }
});

});


parcelRegister("592OP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db25af6051e1db81$export$2e2bcd8739ae039; });
/* hero-text-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $8IYGL = parcelRequire("8IYGL");

var $asbmK = parcelRequire("asbmK");

var $6KUQg = parcelRequire("6KUQg");

var $irRyj = parcelRequire("irRyj");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $gfjAv = parcelRequire("gfjAv");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $izdHQ = parcelRequire("izdHQ");

var $02dyT = parcelRequire("02dyT");
const $db25af6051e1db81$var$sectionStyle = null;
const $db25af6051e1db81$var$relative = null;
const $db25af6051e1db81$var$wrapper = null;
const $db25af6051e1db81$var$embeddedSignupStyle = null;
const $db25af6051e1db81$var$submitWrapperStyle = null;
const $db25af6051e1db81$var$socialWrapperStyle = null;
const $db25af6051e1db81$export$86cbf5054d71d20c = ({ lineBreak: lineBreak = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "ConfluenceSoftwarePage.v4.heroHeader",
        defaultMessage: "Goodbye silos, <bold-text>hello</bold-text> <underline-comp>teamwork</underline-comp>",
        values: {
            'bold-text': (node)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        lineBreak && /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: "superhero",
                            children: node
                        })
                    ]
                }),
            'underline-comp': (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                    underlineInset: "-28%",
                    underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i01olj0l1c7t5w32dncm1wn5853ibm16.svg',
                            alt: 'hero underline'
                        }
                    }),
                    children: node
                })
        }
    });
};
const $db25af6051e1db81$var$HeroTextSection = ({ userProfile: userProfile })=>{
    const intl = (0, $8e22h.default)();
    const ctaText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.heroCTA',
        defaultMessage: 'Get Confluence free'
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const embeddedSignup = !userProfile;
    (0, $izdHQ.useFeatureExposed)('cfind-2432_embedded_sign-up_confluence_unpaid_pt', 'Test', {
        conditions: [
            embeddedSignup
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-heroTextSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_85i5pxbi _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _1kt9b3bt _1cs8stnw _z5wtidpf _iajmidpf _1y8l1git _1mp4auwl _kfgt1osq _1s6k1bjw _tgsmz517 _1g0v1mrw"
                    ]),
                    style: {
                        "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f6nhw _1e0c1txw _1bah1h6o _4cvr1h6o _zulp1wto _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1gde1bp4 _8164idpf",
                            embeddedSignup && "_1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $02dyT.default), {
                                header: /*#__PURE__*/ (0, $7VQPk.jsx)($db25af6051e1db81$export$86cbf5054d71d20c, {
                                    lineBreak: embeddedSignup
                                }),
                                subHeader: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "ConfluenceSoftwarePage.v4.heroSubHeading",
                                    defaultMessage: "Create, share, and harness knowledge across teams"
                                }),
                                leftAligned: embeddedSignup,
                                cta: !embeddedSignup && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'heroSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                        variant: "primary",
                                        size: "large",
                                        color: "blue",
                                        onClick: openCrossFlow,
                                        href: signupLink,
                                        dataEventProps: {
                                            'data-product-key': 'confluence',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'heroSection',
                                            'data-label': 'hero-get-confluence-free',
                                            'data-label-english': 'Get Confluence free',
                                            'data-track-event': 'confluence-pt.get-confluence-free.cta'
                                        },
                                        children: ctaText
                                    }, 'confluence')
                                })
                            }),
                            embeddedSignup && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1qbf _ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1u2qidpf _1vdkidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                                    Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {
                                        helpText: null
                                    }),
                                    Submit: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1o7p1j6v _1wtni2wt _d4lf1ylp"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {})
                                    }),
                                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_jk7416hb _1b94glyw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                                            providers: {
                                                google: 'Google',
                                                apple: 'Apple',
                                                slack: 'Slack'
                                            }
                                        })
                                    }),
                                    Login: null
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
$db25af6051e1db81$var$HeroTextSection.displayName = 'HeroTextSection';
var $db25af6051e1db81$export$2e2bcd8739ae039 = $db25af6051e1db81$var$HeroTextSection;

});

parcelRegister("cWN5u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4fd8df2d7726aaf5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $cAI5M = parcelRequire("cAI5M");

var $je135 = parcelRequire("je135");
const $4fd8df2d7726aaf5$var$IntegrationsSection = ()=>{
    const intl = (0, $8e22h.default)();
    const iconData = [
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.jira-logo-alt',
                defaultMessage: 'The Jira logo which resembles three arrowheads pointing up and to the right.'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/jira-integration')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.loom-logo-alt',
                defaultMessage: 'Loom logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1225947/loom-for-confluence'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.trello-logo-alt',
                defaultMessage: 'Trello logo which resembles a trello board with two columns.'
            }),
            href: (0, $jQ0cd.useLocalizedHrefTrello)('/')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.microsoft-teams-logo-alt',
                defaultMessage: 'Microsoft Teams logo'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/microsoft-teams-integration')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.figma-logo-alt',
                defaultMessage: 'Figma logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1221692/figma-for-confluence'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.slack-logo-alt',
                defaultMessage: 'Slack logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.google-drive-logo-alt',
                defaultMessage: 'Google Drive logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1216978/google-drive-and-docs-for-confluence'
        }
    ];
    const headingText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.header',
        defaultMessage: 'Integrate with your faves'
    });
    const bodyText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.body',
        defaultMessage: 'All the tools you know and love integrate smoothly with Confluence'
    });
    const ctaText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.cta',
        defaultMessage: 'Go to Marketplace'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-integrationsSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
            section: "IntegrationsSection",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cAI5M.Adg4OffsetIconCollection), {
                iconData: iconData,
                headingText: headingText,
                bodyText: bodyText,
                ctaText: ctaText,
                productKey: "confluence",
                ctaLink: "https://marketplace.atlassian.com/addons/app/confluence"
            })
        })
    });
};
$4fd8df2d7726aaf5$var$IntegrationsSection.displayName = 'IntegrationsSection';
var $4fd8df2d7726aaf5$export$2e2bcd8739ae039 = $4fd8df2d7726aaf5$var$IntegrationsSection;

});
parcelRegister("cAI5M", function(module, exports) {
$parcel$export(module.exports, "Adg4OffsetIconCollection", function () { return $e95e9453f4d3c6cc$export$df552133577e6dc7; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $lmQGF = parcelRequire("lmQGF");

var $kbpa7 = parcelRequire("kbpa7");
const $e95e9453f4d3c6cc$var$sectionContainer = null;
const $e95e9453f4d3c6cc$var$contentContainer = null;
const $e95e9453f4d3c6cc$var$textContainerStyles = null;
const $e95e9453f4d3c6cc$var$headingTextStyles = null;
const $e95e9453f4d3c6cc$var$bodyTextStyles = null;
const $e95e9453f4d3c6cc$var$iconContainerStyles = null;
const $e95e9453f4d3c6cc$var$iconStyles = null;
const $e95e9453f4d3c6cc$var$linkStyles = null;
const $e95e9453f4d3c6cc$var$animationStyle = null;
const $e95e9453f4d3c6cc$export$df552133577e6dc7 = ({ iconData: iconData, textPosition: textPosition = 'right', headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, productKey: productKey, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const isExternalHref = ctaLink.startsWith('https://');
    const textSection = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1h6o _1gde1bp4 _ag851h6o _xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1mouidpf"
                ]),
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1mouidpf _1pfh1kwk _6rth1k8s _p12f1yxl _8fz6jbd8"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                variant: "secondary",
                size: "large",
                color: "black",
                href: ctaLink,
                target: isExternalHref ? '_blank' : undefined,
                rel: isExternalHref ? 'noreferrer noopener' : undefined,
                onClick: ctaOnClickFunc,
                dataEventProps: productKey ? {
                    'data-product-key': productKey,
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'integrationsSection',
                    'data-label': 'integrations-cta',
                    'data-track-event': 'integrations.cta'
                } : undefined,
                children: ctaText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mouviql _zulp1et3 _1p5sckbl _1gzv14no _suga1txw _1gde1bp4 _ag851h6o _81641tcg"
            ]),
            children: [
                textPosition !== 'right' && textSection,
                /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp6veu _1bah1h6o _ae4v1h6o _p12f1vci _1o9zidpf _qtt8glyw _18zridpf _1p5s1bkc _ceho1byl _2osn7vkz _8fz6jbd8"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: icon.href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: icon.href,
                                "data-product-key": productKey,
                                "data-event-container": "integrationsSection",
                                "data-event-component": "linkButton",
                                "data-label": icon.altText,
                                "data-event": "clicked",
                                "data-track-event": "integrations.icon",
                                className: (0, $2jatx.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q71afi _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    "_80omtlke _16qs1yxe _1dbzjojz",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q71afi _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            })
                        }, index))
                }),
                textPosition === 'right' && textSection
            ]
        })
    });
};

});


parcelRegister("4sY9l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0736add56ee2978$export$2e2bcd8739ae039; });
/* scroller-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $jr060 = parcelRequire("jr060");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $4hIcA = parcelRequire("4hIcA");

var $je135 = parcelRequire("je135");
const $e0736add56ee2978$var$contentStyles = null;
const $e0736add56ee2978$var$headingStyles = null;
const $e0736add56ee2978$var$textStyles = null;
const $e0736add56ee2978$var$scrollerHeading = null;
const $e0736add56ee2978$var$buttonContainer = null;
const $e0736add56ee2978$var$arrowStyles = null;
const $e0736add56ee2978$var$sectionStyle = null;
const $e0736add56ee2978$var$arrowInAnimation = null;
const $e0736add56ee2978$export$272f9c9325d00e8b = (props)=>{
    const transformStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "72",
        height: "25",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _5sag9cwz _ju251yx9 _tip8kb7n _1o51eoah",
            props.animate && "_j7hqxb4k"
        ]),
        style: {
            insetInlineStart: props.left,
            insetInlineEnd: props.right,
            insetBlockStart: props.top,
            insetBlockEnd: props.bottom,
            transform: `rotate(${props.rotate ? props.rotate : '0'}deg)`,
            color: props.color ? props.color : 'currentColor',
            visibility: props.animate ? 'visible' : 'hidden',
            "--_l8fg41": (0, $6ZVlx.default)(props.rotate ?? 0, "deg")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $e0736add56ee2978$var$AnimatedArrowButton = ({ href: href, text: text, onClick: onClick, label: label, labelEnglish: labelEnglish })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 1
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1o8l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                href: href,
                color: "blue",
                size: "large",
                onClick: onClick,
                dataEventProps: {
                    'data-product-key': 'confluence',
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'scrollPinnedSection',
                    'data-label': label,
                    'data-label-english': labelEnglish
                },
                children: text
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: 180,
                right: -88,
                top: "25%",
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: -140,
                right: -61,
                bottom: -49,
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: -121,
                right: 0,
                bottom: -62,
                animate: sectionIsVisible
            })
        ]
    });
};
const $e0736add56ee2978$var$ScrollerContent = ({ item: item })=>{
    const { ref: ref } = (0, $je135.useScrollTracking)(`ScrollerSectionItem-${item.id}`);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: item.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q517vkz _85i51tcg"
                ]),
                children: item.description
            }),
            item.link && item.link.type === 'link' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: item.link.text,
                "aria-label": item.link.ariaLabelText,
                href: item.link.href,
                onClick: item.link.onClick,
                dataEventProps: {
                    'data-product-key': 'confluence',
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'scrollPinnedSection',
                    'data-label': item.link.label,
                    'data-label-english': item.link.labelEnglish
                }
            }),
            item.link && item.link.type === 'button' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                intentType: 'button',
                containerId: 'scrollPinnedSection',
                productKey: 'confluence',
                edition: 'free',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$var$AnimatedArrowButton, {
                    href: item.link.href,
                    text: item.link.text,
                    onClick: item.link.onClick,
                    label: item.link.label,
                    labelEnglish: item.link.labelEnglish
                })
            })
        ]
    });
};
const $e0736add56ee2978$var$ScrollerSection = ()=>{
    const intl = (0, $8e22h.default)();
    const featuresLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/features');
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const { ref: ref } = (0, $je135.useScrollTracking)('ScrollerSection', {
        observerOptions: {
            threshold: 0.1
        }
    });
    const items = [
        {
            id: '1-files',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.1.title',
                defaultMessage: 'From files to freedom'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.1.description',
                defaultMessage: 'Create dynamic Pages with all kinds of content, like Whiteboards, Databases, and videos. Pull in all your work to reduce context-switching.'
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-2.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.imgAlt',
                    defaultMessage: 'image of a confluence page'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.lime'),
            lazyLoadImage: true,
            bgShape: '0% 29%, 42% 28%, 43% 5%, 100% 0%, 100% 95%, 60% 95%, 60% 100%, 2% 93%, 2% 93%, 2% 93%',
            link: {
                type: 'link',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.linkText',
                    defaultMessage: 'See more features'
                }),
                label: 'see-more-features',
                labelEnglish: 'See more features',
                href: featuresLink,
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.linkAriaLabel',
                    defaultMessage: 'See more features of Confluence'
                })
            }
        },
        {
            id: '2-work',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.2.title',
                defaultMessage: 'Your shortcut for accelerating work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.2.description',
                defaultMessage: "Eliminate writer\u2019s block, automate repetitive tasks, and summarize lengthy docs with AI."
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-1-updated.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.imgAlt',
                    defaultMessage: 'image of Atlassian Intelligence on a confluence page'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.purple'),
            lazyLoadImage: true,
            bgShape: '6% 28%, 52% 23%, 53% 5%, 100% 0%, 100% 99%, 6% 96%, 6% 89%, 0% 88%, 0% 51%, 7% 50%',
            link: intl.locale === 'en' ? {
                type: 'link',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.linkText',
                    defaultMessage: 'Try it out'
                }),
                label: 'try-it-out',
                labelEnglish: 'Try it out',
                href: 'https://www.atlassian.com/confluence-sandbox-editor',
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.linkAriaLabel',
                    defaultMessage: 'Try out Confluence for free'
                })
            } : undefined
        },
        {
            id: '3-teams',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.3.title',
                defaultMessage: 'Connect the dots across your teams'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.3.description',
                defaultMessage: "Build a source of truth for all teams. Stay caught up across your company with organized content and knowledge that's easily findable and always up-to-date."
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-3.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.imgAlt',
                    defaultMessage: 'image of a deliverable & outcomes document in confluence'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.saffron'),
            lazyLoadImage: true,
            bgShape: '0% 25%, 42% 20%, 42% 5%, 100% 0%, 100% 95%, 51% 100%, 50% 94%, 3% 95%, 3% 95%, 3% 95%',
            link: {
                type: 'button',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.linkText',
                    defaultMessage: 'Get started free'
                }),
                label: 'get-started-free',
                labelEnglish: 'Get started free',
                href: signupLink,
                onClick: openCrossFlow,
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.linkAriaLabel',
                    defaultMessage: 'Get started with Confluence for free'
                })
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-scrollerSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: ref,
            className: (0, $2jatx.default)([
                "_1reozryt _18m9zryt"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hIcA.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item, activeIndex, mobileSpecific)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jr060.Adg4FramedImage), {
                        feature: item.feature,
                        accent: item.accent,
                        bgShape: item.bgShape,
                        bgColor: item.bgColor,
                        lazyLoadImage: item.lazyLoadImage,
                        activeIndexIsEven: !mobileSpecific ? activeIndex % 2 === 0 : undefined
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _1bsb1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "ConfluenceSoftwarePage.v4.scroller.heading",
                        defaultMessage: "Your team\u2019s knowledge, all in one place"
                    })
                })
            })
        })
    });
};
var $e0736add56ee2978$export$2e2bcd8739ae039 = $e0736add56ee2978$var$ScrollerSection;

});
parcelRegister("jr060", function(module, exports) {
$parcel$export(module.exports, "Adg4FramedImage", function () { return $aff033e41e7c32d0$export$3c140a884be9e13d; });
/* framed-image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ep4tq = parcelRequire("ep4tq");
const $aff033e41e7c32d0$export$3c140a884be9e13d = ({ feature: feature, accent: accent, bgShape: bgShape, bgColor: bgColor, activeIndexIsEven: activeIndexIsEven, lazyLoadImage: lazyLoadImage = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1h1t15ju"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: {
                        clipPath: `polygon(${bgShape})`,
                        backgroundColor: bgColor
                    },
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _4t3i1osq _v564t24z _kqswstnw _1e02idpf _152tidpf",
                        activeIndexIsEven === true && "_y44v1cly",
                        activeIndexIsEven === false && "_y44vh8q8"
                    ])
                }),
                accent ? /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: accent.src,
                    className: (0, $2jatx.default)([
                        "_1bsbx19p _kqswstnw _1e02idpf _u7co15qf",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22",
                        accent.className
                    ]),
                    alt: accent.alt,
                    loading: lazyLoadImage ? 'lazy' : undefined
                }) : '',
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq _ca0q19nj _u5f316gx _n3td19nj _19bv16gx _rtys1osq",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ep4tq.Adg4RaisedMedia), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            className: feature.className,
                            loading: lazyLoadImage ? 'lazy' : undefined,
                            src: feature.src,
                            alt: feature.alt
                        })
                    })
                })
            ]
        })
    });
};
const $aff033e41e7c32d0$var$framedImageStyles = null;
const $aff033e41e7c32d0$var$imgRegion = null;
const $aff033e41e7c32d0$var$featureImageStyle = null;
const $aff033e41e7c32d0$var$accentImageStyle = null;
const $aff033e41e7c32d0$var$bgShapeStyle = null;
const $aff033e41e7c32d0$var$activeEvenBgStyle = null;
const $aff033e41e7c32d0$var$activeOddBgStyle = null;
const $aff033e41e7c32d0$var$activeEvenImgStyle = null;
const $aff033e41e7c32d0$var$activeOddImgStyle = null;

});


parcelRegister("5v7eV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b5236b6b57b7b0a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $bQjAr = parcelRequire("bQjAr");

var $esXU7 = parcelRequire("esXU7");
const $6b5236b6b57b7b0a$var$SocialEndorsementSection = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-socialEndorsementSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $esXU7.SocialEndorsement), {})
    });
$6b5236b6b57b7b0a$var$SocialEndorsementSection.displayName = 'SocialEndorsementSection';
var $6b5236b6b57b7b0a$export$2e2bcd8739ae039 = $6b5236b6b57b7b0a$var$SocialEndorsementSection;

});
parcelRegister("esXU7", function(module, exports) {
$parcel$export(module.exports, "SocialEndorsement", function () { return $8df6c0f40bfd1ce3$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1rGpC = parcelRequire("1rGpC");
const $8df6c0f40bfd1ce3$var$logosContainerStyle = null;
const $8df6c0f40bfd1ce3$var$logoStyle = null;
const $8df6c0f40bfd1ce3$export$782656e60c9cecfd = ()=>{
    const logos = [
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg',
            alt: 'Canva',
            width: 95
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg',
            alt: 'NASA',
            width: 60
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg',
            alt: 'Illumina',
            width: 103
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg',
            alt: 'Docker',
            width: 108
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg',
            alt: 'The New York Times',
            width: 165
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg',
            alt: 'Audi',
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_6a6z1h6o _4cvr1h6o _1pfhckbl _6rthzwfg _195g1wug _1bsb1osq _10jx1fa8 _msupitcz _181n1txw _zkhy1g80 _e8gh1h6o _1to91tcg _99s6ckbl _14b51osq _j6qucv93 _suga11p5 _131y7vkz _1d4s1tcg _19d7910g _1rkbcv93 _1rfm1osq _1m0a11p5 _6j7rftgi _1dw37vkz _1s8mfsjm"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $2jatx.default)([
                            "_lcxvglyw _kdamllbs _16bullbs _95u51cm0 _14dm2k2r"
                        ])
                    })
                }, index))
        })
    });
};

});


parcelRegister("bFVFT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b19cbfc74e1ab266$export$2e2bcd8739ae039; });
/* templates-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $keCPI = parcelRequire("keCPI");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $hzLa4 = parcelRequire("hzLa4");

var $je135 = parcelRequire("je135");

var $59uc6 = parcelRequire("59uc6");
const $b19cbfc74e1ab266$var$tabsWrapper = null;
const $b19cbfc74e1ab266$var$headingStyle = null;
const $b19cbfc74e1ab266$var$linkStyle = null;
// Prevent height jump when image is loading
const $b19cbfc74e1ab266$var$contentHeight = null;
function $b19cbfc74e1ab266$var$item(intl, title, description, imgSrc, templateLinkPrefix, templateSlug, lazyLoad = true) {
    const titleText = intl.formatMessage(title);
    const headingId = `${templateSlug}-heading`;
    const linkId = `${templateSlug}-link`;
    return {
        title: titleText,
        description: intl.formatMessage(description),
        expandAriaLabel: intl.formatMessage((0, $59uc6.templatesSectionMessages).expandAriaLabel, {
            title: titleText
        }),
        content: // eslint-disable-next-line no-restricted-syntax
        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            alt: "",
            loading: lazyLoad ? 'lazy' : undefined,
            src: imgSrc,
            width: "100%"
        }),
        link: // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: intl.formatMessage((0, $59uc6.templatesSectionMessages).tryItOut),
            href: templateLinkPrefix + '/' + templateSlug,
            dataEventProps: {
                'data-product-key': 'confluence',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'templatesSection',
                'data-label': templateSlug,
                'data-label-english': 'Try it out',
                'data-track-event': 'confluence-pt.templates.try-it-out'
            },
            id: linkId,
            ariaLabelledby: `${headingId} ${linkId}`
        }),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event': 'clicked',
            'data-event-component': 'carouselItem',
            'data-event-container': 'templatesSection',
            'data-label': templateSlug,
            'data-label-english': typeof title.defaultMessage === 'string' ? title.defaultMessage : undefined,
            'data-track-event': 'confluence-pt.templates.list-item'
        },
        headingId: headingId
    };
}
const $b19cbfc74e1ab266$var$TabContent = ({ category: category })=>{
    const { goToNextTab: goToNextTab, userSelected: userSelected } = (0, $iyOcM.useAdg4TabsContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hzLa4.ListContentCycle), {
        items: category.items,
        listHeading: category.categoryTitle,
        onCycleEnd: ()=>{
            if (!userSelected) goToNextTab();
        }
    });
};
const $b19cbfc74e1ab266$var$TemplatesSection = ()=>{
    const intl = (0, $8e22h.default)();
    const templatesLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/templates');
    const templateCategories = [
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionMarketingMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionMarketingMessages).contentHeading),
            eventProps: {
                label: 'marketing-and-sales',
                labelEnglish: 'Marketing'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template1Heading, (0, $59uc6.templatesSectionMarketingMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-01-plan.webp', templatesLink, 'marketing-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template2Heading, (0, $59uc6.templatesSectionMarketingMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-02-competitive-analysis.webp', templatesLink, 'competitive-analysis'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template3Heading, (0, $59uc6.templatesSectionMarketingMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-03-campaign.webp', templatesLink, 'marketing-campaign')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionProjectPlanningMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionProjectPlanningMessages).contentHeading),
            eventProps: {
                label: 'project-planning',
                labelEnglish: 'Project Planning'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template1Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-01-brainstorm.webp', templatesLink, 'brainstorming'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template2Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-02-plan.webp', templatesLink, 'project-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template3Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-03-roles.webp', templatesLink, 'roles-and-responsibilities')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionSoftwareMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionSoftwareMessages).contentHeading),
            eventProps: {
                label: 'software-development',
                labelEnglish: 'Software'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template1Heading, (0, $59uc6.templatesSectionSoftwareMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-01-sprint-planning.webp', templatesLink, 'sprint-planning-meeting'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template2Heading, (0, $59uc6.templatesSectionSoftwareMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-02-experiment-plan.webp', templatesLink, 'experiment-plan-and-results'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template3Heading, (0, $59uc6.templatesSectionSoftwareMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-03-devops-runbook.webp', templatesLink, 'devops-runbook')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionProductManagementMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionProductManagementMessages).contentHeading),
            eventProps: {
                label: 'product-management',
                labelEnglish: 'Product Management'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template1Heading, (0, $59uc6.templatesSectionProductManagementMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-01-requirements.webp', templatesLink, 'product-requirements'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template2Heading, (0, $59uc6.templatesSectionProductManagementMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-02-roadmap.webp', templatesLink, 'product-roadmap'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template3Heading, (0, $59uc6.templatesSectionProductManagementMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-03-launch.webp', templatesLink, 'product-launch')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionBusinessStrategyMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionBusinessStrategyMessages).contentHeading),
            eventProps: {
                label: 'business-strategy',
                labelEnglish: 'Business Strategy'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template1Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-01-vision.webp', templatesLink, 'vision-to-values'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template2Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-02-strategic-plan.webp', templatesLink, 'strategic-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template3Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-03-updates.webp', templatesLink, 'business-status-update')
            ]
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-templatesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1pbykb7n _1xgm1crf _vnhn1ylp _x3vx7vkz _zfbj1f4h"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _6rthidpf"
                        ]),
                        children: intl.formatMessage((0, $59uc6.templatesSectionMessages).heading)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                            className: "tab-list",
                            children: templateCategories.map((category, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                    className: "round-tab",
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'tab',
                                        'data-event-container': 'templatesSection',
                                        'data-label': category.eventProps.label,
                                        'data-label-english': category.eventProps.labelEnglish,
                                        'data-track-event': 'confluence-pt.templates.tab'
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $keCPI.RoundTab), {
                                        title: category.tabName
                                    })
                                }, index);
                            })
                        }),
                        templateCategories.map((category, index)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19451pl1"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($b19cbfc74e1ab266$var$TabContent, {
                                        category: category
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1k9pzwfg _1tntvbgk"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: intl.formatMessage((0, $59uc6.templatesSectionMessages).seeAllTemplates),
                            href: templatesLink,
                            dataEventProps: {
                                'data-product-key': 'confluence',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'templatesSection',
                                'data-label': 'see-all-templates',
                                'data-label-english': 'See all templates',
                                'data-track-event': 'confluence-pt.templates.see-all-templates'
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $b19cbfc74e1ab266$export$2e2bcd8739ae039 = (0, $je135.withScrollTracking)('TemplatesSection', $b19cbfc74e1ab266$var$TemplatesSection, {
    observerOptions: {
        threshold: 0.1
    }
});

});
parcelRegister("keCPI", function(module, exports) {
$parcel$export(module.exports, "RoundTab", function () { return $2c8e0b9e6af3661f$export$e748343268edd19c; });
/* round-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $2c8e0b9e6af3661f$var$tabStyle = null;
const $2c8e0b9e6af3661f$var$selectedTabStyle = null;
const $2c8e0b9e6af3661f$export$e748343268edd19c = ({ isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhkdkka _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i8vuz _2rko1f4h _y4tigktf _bozggktf _80omtlke _19itn6xs _k48pbfng _1wyb1k92 _ect41vau _bfw71tdf _irr31bjw",
            isSelected && "_19it1tdf _syazvb1l"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: title
    });
};

});

parcelRegister("hzLa4", function(module, exports) {
$parcel$export(module.exports, "ListContentCycle", function () { return $57669ce4acf66392$export$d6db5cefb2f41a42; });
/* list-content-cycle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");
const $57669ce4acf66392$var$wrapperStyle = null;
const $57669ce4acf66392$var$contentWrapper = null;
const $57669ce4acf66392$var$textItemStyles = null;
const $57669ce4acf66392$var$graphicStyles = null;
const $57669ce4acf66392$var$itemContainer = null;
const $57669ce4acf66392$var$itemStyles = null;
const $57669ce4acf66392$var$buttonStyle = null;
const $57669ce4acf66392$var$headingStyle = null;
const $57669ce4acf66392$var$noMarginStyle = null;
const $57669ce4acf66392$var$textLinkStyle = null;
const $57669ce4acf66392$var$visibleTextLink = null;
const $57669ce4acf66392$var$progressBar = null;
const $57669ce4acf66392$var$barFillStyle = null;
const $57669ce4acf66392$var$fullBarStyle = null;
const $57669ce4acf66392$var$mobileContentStyles = null;
const $57669ce4acf66392$var$contentStyles = null;
const $57669ce4acf66392$var$activeContentMedia = null;
const $57669ce4acf66392$var$activeContentStyle = null;
const $57669ce4acf66392$export$d6db5cefb2f41a42 = ({ items: items, heading: heading, listHeading: listHeading, duration: duration = 5000, onCycleEnd: onCycleEnd })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const [activeItem, setActiveItem] = (0, $1oC0p.useState)(0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const animation = null;
    const changeActive = (index, setSelected = false)=>{
        if (onCycleEnd && index >= items.length) onCycleEnd();
        if (setSelected) setUserSelected(true);
        setActiveItem(index >= items.length ? 0 : index);
    };
    // resume loop after comes back into view
    (0, $1oC0p.useEffect)(()=>{
        if (sectionIsVisible) setUserSelected(false);
    }, [
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: scrollRef,
            className: (0, $2jatx.default)([]),
            children: [
                heading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_85i51tcg"
                    ]),
                    children: heading
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _zulpys9h"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulpzwfg _16jlidpf _1o9zidpf _i0dl1osq _10m4idpf _1vdkidpf _1wzn19wn"
                            ]),
                            children: [
                                listHeading && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: listHeading
                                }),
                                items.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswh2mm _1e0c1txw _2lx21bp4 _y3gnv2br _bozg1tcg"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_kqswstnw _152tidpf _u7coidpf _1e02idpf _1bsb1l7b _bfhk1kby"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            onAnimationEnd: ()=>{
                                                                if (userSelected) return;
                                                                changeActive(index + 1);
                                                            },
                                                            className: (0, $2jatx.default)([
                                                                "_11q75hrz _4t3iidpf",
                                                                sectionIsVisible && !userSelected && activeItem === index && "_y44v1she",
                                                                userSelected && activeItem === index && "_4t3i1osq"
                                                            ]),
                                                            style: {
                                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                                "--_1bg9z7q": (0, $6ZVlx.default)(duration, "ms")
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                        "aria-label": item.expandAriaLabel,
                                                        "aria-expanded": activeItem === index,
                                                        onClick: ()=>{
                                                            changeActive(index, true);
                                                        },
                                                        ...item.dataEventProps,
                                                        className: (0, $2jatx.default)([
                                                            "_y3gn1e5h _11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _18zridpf _1rjcidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                            id: item.headingId,
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                            ]),
                                                            children: item.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _2lx21bp4 _zulpftgi _v5641tqq _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq",
                                                            activeItem === index && "_c71lmgvx _1rjc1y44"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                className: (0, $2jatx.default)([
                                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                                ]),
                                                                children: item.description
                                                            }),
                                                            item.link
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_v564ayzn _1e0cglyw _1reo15vq _18m915vq _tzy4idpf _1rjc7vkz",
                                                    activeItem === index && "_tzy4kb7n _1mjb1ule"
                                                ]),
                                                children: item.content
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                            ]),
                            children: items.map((item, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_v564ayzn _1lww1yx9 _4t3iidpf _tzy4idpf _1reo15vq _18m915vq _1mjbglyw",
                                        activeItem === index && "_4t3i1wug _tzy4kb7n _dm251ule"
                                    ]),
                                    children: item.content
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("59uc6", function(module, exports) {
$parcel$export(module.exports, "templatesSectionMessages", function () { return $9d33a1f63a3db544$export$918efc24479364d; });
$parcel$export(module.exports, "templatesSectionMarketingMessages", function () { return $9d33a1f63a3db544$export$217732740ce81bfa; });
$parcel$export(module.exports, "templatesSectionProjectPlanningMessages", function () { return $9d33a1f63a3db544$export$6b54437a0a39225d; });
$parcel$export(module.exports, "templatesSectionSoftwareMessages", function () { return $9d33a1f63a3db544$export$4c78b2adf33c9c13; });
$parcel$export(module.exports, "templatesSectionProductManagementMessages", function () { return $9d33a1f63a3db544$export$b3ac84acded839df; });
$parcel$export(module.exports, "templatesSectionBusinessStrategyMessages", function () { return $9d33a1f63a3db544$export$d594459a0e83d76e; });

var $fnHPc = parcelRequire("fnHPc");
const $9d33a1f63a3db544$export$918efc24479364d = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.heading',
        defaultMessage: 'Confluence is for every team'
    },
    seeAllTemplates: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.seeAllTemplates',
        defaultMessage: 'See all templates'
    },
    tryItOut: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.tryItOut',
        defaultMessage: 'Try it out'
    },
    expandAriaLabel: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.expandAriaLabel',
        defaultMessage: 'Expand {title}'
    },
    imgAlt: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.imgAlt',
        defaultMessage: 'Image of {title} template'
    }
});
const $9d33a1f63a3db544$export$217732740ce81bfa = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.tabName',
        defaultMessage: 'Marketing'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.heading',
        defaultMessage: 'Templates for marketing teams'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.heading',
        defaultMessage: 'Marketing plan'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.description',
        defaultMessage: 'Nail your GTM strategy and plan marketing programs with your team'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.heading',
        defaultMessage: 'Competitive analysis'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.description',
        defaultMessage: 'Collaboratively document competitor offerings & strategies'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.heading',
        defaultMessage: 'Marketing campaign'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.description',
        defaultMessage: 'Build a solid campaign blueprint to drive impact'
    }
});
const $9d33a1f63a3db544$export$6b54437a0a39225d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.tabName',
        defaultMessage: 'Project Planning'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.heading',
        defaultMessage: 'Templates for project planning'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.heading',
        defaultMessage: 'Brainstorm'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.description',
        defaultMessage: 'Lead a productive brainstorming session and ideate on the most impactful work'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.heading',
        defaultMessage: 'Project plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.description',
        defaultMessage: 'Map out your project logistics and move your team across the finish line, every time.'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.heading',
        defaultMessage: 'Roles & responsibilities'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.description',
        defaultMessage: 'Clarify individual roles and responsibilities to build a strong project team'
    }
});
const $9d33a1f63a3db544$export$4c78b2adf33c9c13 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.tabName',
        defaultMessage: 'Software'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.heading',
        defaultMessage: 'Templates for software teams'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.heading',
        defaultMessage: 'Sprint planning'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.description',
        defaultMessage: 'Set goals, plan team capacity, and effectively kick off every sprint'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.heading',
        defaultMessage: 'Experiment plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.description',
        defaultMessage: 'Streamline your experiment process to more effectively test and learn'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.heading',
        defaultMessage: 'DevOps runbook'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.description',
        defaultMessage: 'Help your operations team respond to system alerts and outages'
    }
});
const $9d33a1f63a3db544$export$b3ac84acded839df = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.tabName',
        defaultMessage: 'Product Management'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.heading',
        defaultMessage: 'Templates for product management'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.heading',
        defaultMessage: 'Product requirements'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.description',
        defaultMessage: 'Outline your pre-launch prep and track your post-launch progress'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.heading',
        defaultMessage: 'Product roadmap'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.description',
        defaultMessage: 'Transform your product features from ideas to reality'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.heading',
        defaultMessage: 'Product launch'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.description',
        defaultMessage: 'Your ultimate liftoff planning doc'
    }
});
const $9d33a1f63a3db544$export$d594459a0e83d76e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.tabName',
        defaultMessage: 'Business Strategy'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.heading',
        defaultMessage: 'Templates for business strategy'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.heading',
        defaultMessage: 'Vision to values'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.description',
        defaultMessage: 'Align business strategies with company mission'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.heading',
        defaultMessage: 'Strategic plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.description',
        defaultMessage: 'Turn your business vision into actionable next steps'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.heading',
        defaultMessage: 'Business status updates'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.description',
        defaultMessage: 'Share performance results and customer insights across the team'
    }
});

});


parcelRegister("iuSIG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb9283c42d2a5c48$export$2e2bcd8739ae039; });
/* testimonial-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $jQ0cd = parcelRequire("jQ0cd");

var $h8tN9 = parcelRequire("h8tN9");

var $dweoU = parcelRequire("dweoU");
const $cb9283c42d2a5c48$var$logoSizeStyles = null;
const $cb9283c42d2a5c48$var$TestimonialsSection = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.name',
                defaultMessage: 'Damien Davis'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialDropbox), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.title',
                defaultMessage: 'Lead Atlassian Administrator, Dropbox'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-dropbox.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.quote',
                defaultMessage: 'Confluence out of the box is a fantastic product, and integrations take it to another level. We can embed videos, media, and all sorts of files and make them accessible across the enterprise.'
            }),
            label: 'Dropbox'
        },
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.name',
                defaultMessage: 'Joe Cotant'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialRoblox), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.title',
                defaultMessage: 'Senior Technical Program Manager, Roblox'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-roblox.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.quote',
                defaultMessage: 'Using smart links within Confluence and Jira makes cross-team collaboration much easier. These integrations have been pivotal in collaboration, productivity, and discoverability.'
            }),
            label: 'Roblox'
        },
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.name',
                defaultMessage: 'Rob Mulvaney'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.title',
                defaultMessage: 'Director, Agile Transformation Office, Lumen Technologies'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-lumen.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.quote',
                defaultMessage: 'Employees across the company use Confluence to document important information like objectives and key results, which helps keep teams aligned across the big-picture goals.'
            }),
            label: 'Lumen'
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-testimonialsSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51ckbl _1av31jry _125xu67f _1com1osq _1bdu18r2 _1c8yor1b"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h8tN9.ADG4CustomerTestimonials), {
                testimonials: testimonials,
                imagePosition: "right",
                testimonialCta: /*#__PURE__*/ (0, $7VQPk.jsx)($cb9283c42d2a5c48$var$TestimonialCta, {})
            })
        })
    });
};
$cb9283c42d2a5c48$var$TestimonialsSection.displayName = 'TestimonialsSection';
const $cb9283c42d2a5c48$var$ctaContainerStyles = null;
const $cb9283c42d2a5c48$var$TestimonialCta = ()=>{
    const intl = (0, $8e22h.default)();
    const customersLink = (0, $jQ0cd.useLocalizedHref)('/customers');
    const linkText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.testimonials.ctaButton.text',
        defaultMessage: 'Explore customer stories'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _mqm25xei _16jlkb7n _4t3i1osq _y4tifatv _1e0c1txw _1bahesu3 _152tt94y _kqswh2mm _xlmcidpf _wnjd1h6o _wm3b189y _4bscidpf _1uwridpf _7sgdidpf _1b3nidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
            href: customersLink,
            variant: "secondary",
            color: "white",
            dataEventProps: {
                'data-product-key': 'confluence',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'testimonialsSection',
                'data-label': 'testimonials-cta',
                'data-label-english': 'Explore customer stories',
                'data-track-event': 'confluence-pt.testimonials.cta'
            },
            children: linkText
        })
    });
};
var $cb9283c42d2a5c48$export$2e2bcd8739ae039 = $cb9283c42d2a5c48$var$TestimonialsSection;

});
parcelRegister("h8tN9", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return $46cab561f3e1a3ae$export$d0511cb0623812b3; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");
// @ts-expect-error unused
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $46cab561f3e1a3ae$var$AUTO_TRANSITION_INTERVAL = 8000;
/* eslint-disable local/ensure-wac-token-usage */ // Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $46cab561f3e1a3ae$var$backgroundColorStyleMap = {
    blue: "_bfhkdoyu",
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $46cab561f3e1a3ae$var$backgroundShapeStyleMap = {
    'image-left': "_mkrz75ra _1vthq8qa",
    'image-right': "_mkrz1ofp _1vth1ofp"
};
const $46cab561f3e1a3ae$var$customerImagesSectionStyleMap = {
    'image-left': "_1461n7od",
    'image-right': "_uhi5cs5v"
};
const $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap = {
    'image-left': "_1461n7od",
    'image-right': "_uhi5kb7n _1fltkb7n"
};
const $46cab561f3e1a3ae$var$fontColorStyleMap = {
    'dark-bg': "_syaz12cp",
    'white-bg': "_syazn7od"
};
const $46cab561f3e1a3ae$var$topLineStyleMap = {
    blue: "_bfhk1nof",
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $46cab561f3e1a3ae$var$logoOptionStyleMap = {
    'dark-bg': "_d4ksu67f _i862u67f",
    'white-bg': "_d4ksr3uz _i862r3uz"
};
const $46cab561f3e1a3ae$export$d0511cb0623812b3 = ({ bgColor: bgColor = 'blue', heading: heading, subheading: subheading, cta: cta, testimonials: testimonials, productKey: productKey, className: className, imagePosition: imagePosition = 'left', testimonialCta: testimonialCta })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const logosContainerStyles = null;
    const bgTheme = bgColor === 'blue' || bgColor === 'black' ? 'dark-bg' : 'white-bg';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                ref: scrollRef,
                className: sectionIsVisible ? 'is-visible' : '',
                children: [
                    !heading && !subheading && !cta ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _6rth1ylp"
                            ]),
                            children: [
                                heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_1mouqlbw",
                                        ""
                                    ]),
                                    children: heading
                                }),
                                subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1mou1kvp",
                                        "body-lg"
                                    ]),
                                    children: subheading
                                }),
                                cta && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    text: cta.text,
                                    href: cta.url,
                                    dataEventProps: cta.dataEventProps,
                                    type: 'primary'
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: scrollRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1pbykb7n _6rth1jfw",
                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                            `${className} ${sectionIsVisible ? 'is-visible' : ''} image-${imagePosition} ${bgColor}-background`
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                            $46cab561f3e1a3ae$var$backgroundColorStyleMap[bgColor],
                                            $46cab561f3e1a3ae$var$backgroundShapeStyleMap[`image-${imagePosition}`],
                                            "bgshape"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                        ]),
                                        children: testimonials.map((testimonial, index)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                                id: `${index}`,
                                                panelIndex: index,
                                                forceRender: true,
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$TopRowContent, {
                                                    testimonial: testimonial,
                                                    imagePosition: imagePosition,
                                                    index: index,
                                                    bgTheme: bgTheme,
                                                    bgColor: bgColor
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
                                            "row-width"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf",
                                                "_1e0c31e1 _1jz91vn9",
                                                "logos-container"
                                            ]),
                                            style: {
                                                "--_1kyqkej": (0, $6ZVlx.default)(testimonialCta ? 'flex' : 'block'),
                                                "--_1chs0f7": (0, $6ZVlx.default)(testimonialCta ? '0' : 'auto')
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $90TSV.Adg4DraggableTabList), {
                                                    className: (0, $2jatx.default)([
                                                        "_6rth1fu0 _1q511aa3 _qtt8agmp",
                                                        "logos"
                                                    ]),
                                                    rowGap: "32px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                                $46cab561f3e1a3ae$var$topLineStyleMap[bgColor],
                                                                "top-line"
                                                            ])
                                                        }),
                                                        testimonials.map((testimonial, index)=>{
                                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                                                as: "button",
                                                                className: (0, $2jatx.default)([
                                                                    $46cab561f3e1a3ae$var$logoOptionStyleMap[bgTheme],
                                                                    "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf",
                                                                    "logo-option"
                                                                ]),
                                                                tabIndex: index,
                                                                dataEventProps: {
                                                                    'data-product-key': productKey,
                                                                    'data-event-component': 'tab',
                                                                    'data-event-container': 'testimonialsSection',
                                                                    'data-event': 'clicked',
                                                                    'data-label-english': testimonial.label
                                                                },
                                                                label: testimonial.label,
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$LogoTabContent, {
                                                                    testimonialLogo: testimonial.logo
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                testimonialCta && testimonialCta
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
const $46cab561f3e1a3ae$var$TopRowContent = ({ testimonial: testimonial, imagePosition: imagePosition, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v",
            "row-width top-row"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug",
                    $46cab561f3e1a3ae$var$customerImagesSectionStyleMap[`image-${imagePosition}`],
                    "customer-images-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: testimonial.title
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb",
                    $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap[`image-${imagePosition}`],
                    "customer-quotes-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _1bahh9n0 _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        "testimonial-quotes-section"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6",
                            "quote-container"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: testimonial.link.type ?? 'primary',
                                bgColor: bgColor === 'blue' || bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                dataEventProps: testimonial.link.dataEventProps
                            })
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $46cab561f3e1a3ae$var$topRowActiveStyle = null;
const $46cab561f3e1a3ae$var$customerImagesImgActiveStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerActiveStyle = null;
const $46cab561f3e1a3ae$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isSelected && "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n",
                        "logo-img-container"
                    ]),
                    children: testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $46cab561f3e1a3ae$var$logoImgStyle = null;
const $46cab561f3e1a3ae$var$logoImgSelectedStyle = null;
const $46cab561f3e1a3ae$var$logoButtonStyle = null;
const $46cab561f3e1a3ae$var$topMarkerStyle = null;
const $46cab561f3e1a3ae$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $46cab561f3e1a3ae$var$headerStyles = null;
const $46cab561f3e1a3ae$var$h2Styles = null;
const $46cab561f3e1a3ae$var$pStyles = null;
const $46cab561f3e1a3ae$var$topLineStyles = null;
const $46cab561f3e1a3ae$var$testimonialKeyframeStyles = null;
const $46cab561f3e1a3ae$var$rowWidthStyle = null;
const $46cab561f3e1a3ae$var$topRowStyle = null;
const $46cab561f3e1a3ae$var$bgShapeStyle = null;
const $46cab561f3e1a3ae$var$customerImagesSectionStyles = null;
const $46cab561f3e1a3ae$var$customerImagesSectionImageStyles = null;
const $46cab561f3e1a3ae$var$customerQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$testimonialQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerPStyle = null;
const $46cab561f3e1a3ae$var$logosContainerBaseStyle = null;
const $46cab561f3e1a3ae$var$logosStyle = null;
const $46cab561f3e1a3ae$var$logoOptionStyle = null;
const $46cab561f3e1a3ae$var$testimonialStyles = null;
const $46cab561f3e1a3ae$var$tabPanelWrapperStyles = null;

});

parcelRegister("dweoU", function(module, exports) {
$parcel$export(module.exports, "TestimonialDropbox", function () { return $ba4696cf403c7502$export$3944c61ebd3bc79e; });
$parcel$export(module.exports, "TestimonialRoblox", function () { return $ba4696cf403c7502$export$d76e3d65f440a2bb; });
$parcel$export(module.exports, "TestimonialLumen", function () { return $ba4696cf403c7502$export$2d5c2c6aa86b2349; });
/* testimonial-logos.tsx generated by @compiled/babel-plugin v0.28.8 */ /* testimonial logos */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $ba4696cf403c7502$export$c237744daee40794 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "25",
        viewBox: "0 0 69 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6992 0.810686C54.0412 0.806395 51.4603 1.7031 49.3776 3.35447C47.295 1.70299 44.714 0.806273 42.056 0.810686C39.3982 0.806573 36.8175 1.70327 34.7348 3.35447C32.6524 1.70291 30.0715 0.806178 27.4136 0.810686C24.7558 0.806573 22.1751 1.70327 20.0924 3.35447C18.0098 1.70321 15.429 0.806512 12.7712 0.810686C6.24899 0.810686 0.963501 6.09579 0.963501 12.6184C0.963501 19.1402 6.2486 24.4261 12.7712 24.4261C15.429 24.4302 18.0097 23.5335 20.0924 21.8823C22.175 23.5336 24.7558 24.4303 27.4136 24.4261C30.0715 24.4305 32.6523 23.5338 34.7348 21.8823C36.8175 23.5335 39.3982 24.4302 42.056 24.4261C44.714 24.4305 47.2949 23.5338 49.3776 21.8823C51.4603 23.5338 54.0412 24.4305 56.6992 24.4261C63.2214 24.4261 68.5065 19.1406 68.5065 12.6184C68.5065 6.09617 63.2214 0.810686 56.6992 0.810686ZM18.1605 19.9534C16.6559 21.051 14.7762 21.7209 12.7712 21.7209C7.73975 21.7209 3.66831 17.6498 3.66831 12.6184C3.66831 7.58693 7.73975 3.5155 12.7712 3.5155C14.7762 3.5155 16.6547 4.18574 18.1605 5.28373C16.5015 7.36796 15.6007 9.95451 15.6063 12.6184C15.6075 15.2812 16.5075 17.8657 18.1605 19.9534ZM20.0928 18.0269C18.9324 16.4627 18.3077 14.5659 18.3115 12.6184C18.3066 10.6707 18.9314 8.77353 20.0928 7.20992C21.2539 8.77365 21.8787 10.6707 21.8741 12.6184C21.8777 14.5659 21.253 16.4627 20.0928 18.0269ZM32.8032 19.9534C31.24 21.1043 29.3486 21.7229 27.4075 21.7182C25.4703 21.7221 23.5832 21.1035 22.0244 19.9534C23.6775 17.866 24.5775 15.2815 24.5785 12.6188C24.5841 9.95489 23.6834 7.36835 22.0244 5.28412C23.583 4.13374 25.4702 3.51491 27.4075 3.51896C29.427 3.51896 31.2929 4.17229 32.8032 5.28412C31.1443 7.36835 30.2435 9.95489 30.2491 12.6188C30.2502 15.2815 31.1502 17.8659 32.8032 19.9534ZM34.7348 18.0269C33.5744 16.4627 32.9497 14.5659 32.9535 12.6184C32.9488 10.6707 33.5736 8.77362 34.7348 7.20992C35.8962 8.77352 36.5212 10.6706 36.5165 12.6184C36.5202 14.566 35.8953 16.4628 34.7348 18.0269ZM47.4457 19.9534C45.9353 21.0656 44.0694 21.7182 42.0503 21.7182C40.0311 21.7182 38.1771 21.0645 36.6668 19.9534C38.32 17.8661 39.22 15.2816 39.2209 12.6188C39.2265 9.95489 38.3258 7.36835 36.6668 5.28412C38.1771 4.17268 40.0311 3.51896 42.0503 3.51896C44.0694 3.51896 45.9353 4.17229 47.4457 5.28412C45.7869 7.36845 44.8862 9.95493 44.8915 12.6188C44.8928 15.2815 45.7928 17.8658 47.4457 19.9534ZM49.378 18.0269C48.2176 16.4627 47.5929 14.5659 47.5967 12.6184C47.5916 10.6706 48.2165 8.77346 49.378 7.20992C50.5391 8.77365 51.1639 10.6707 51.1593 12.6184C51.1628 14.5659 50.5381 16.4626 49.378 18.0269ZM56.6992 21.7209C54.6935 21.7209 52.8142 21.051 51.3099 19.9534C52.9629 17.8659 53.8629 15.2815 53.8641 12.6188C53.8694 9.95493 52.9687 7.36845 51.3099 5.28412C52.8157 4.18651 54.6938 3.51588 56.6992 3.51588C61.7299 3.51588 65.8021 7.58732 65.8021 12.6188C65.8021 17.6495 61.7299 21.7209 56.6992 21.7209Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$7952818aa3b430a7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$53457fb076dd0473 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "71",
        height: "30",
        viewBox: "0 0 71 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M6.19961 0H0.302734V29.4403H6.19961V0ZM21.6954 29.4381H27.5923V9.42706H21.6954V29.4381ZM36.7814 29.4381H43.5707L50.36 9.42706H44.4632C44.4632 9.42706 41.3098 20.2777 40.349 23.7307H40.2807C39.3199 20.2777 36.0982 9.42706 36.0982 9.42706H29.8576L36.7814 29.4381ZM70.9264 9.42706H65.2344V12.175C64.2736 10.0617 62.0127 8.86294 59.3375 8.86294C54.5381 8.86294 50.6972 12.8801 50.6972 19.4315C50.6972 25.9828 54.3993 30 59.0621 30C62.3543 30 64.2736 28.3803 65.3027 26.5469V29.4359H70.9925L70.9264 9.42706ZM65.1 19.9273C65.1 23.5919 62.9052 25.3526 60.7104 25.3526C58.3107 25.3526 56.7329 22.8162 56.7329 19.4337C56.7329 16.0511 58.379 13.5148 60.9153 13.5148C62.9713 13.5148 65.0978 15.2755 65.0978 18.9401V19.9273H65.1ZM7.70688 18.9401C17.1692 18.9401 19.364 10.8374 19.364 9.42706H18.542C9.07973 9.42706 6.88493 17.5297 6.88493 18.9401H7.70688ZM6.88493 19.6452C6.88493 21.1238 8.53103 29.3676 18.6787 29.3676H19.5006C19.5006 27.8889 17.8545 19.6452 7.70688 19.6452H6.88493ZM28.2093 3.93125C28.2093 2.02953 26.7703 0.407668 24.9171 0.407668C24.8488 0.407668 24.7805 0.407668 24.7122 0.407668C22.8611 0.337153 21.2833 1.81578 21.215 3.7197C21.215 3.79022 21.215 3.86073 21.215 3.93125C21.215 5.83297 22.654 7.45483 24.5072 7.45483C24.5755 7.45483 24.6439 7.45483 24.7122 7.45483C26.5632 7.52534 28.141 6.04672 28.2093 4.1428C28.2093 4.07228 28.2093 4.00176 28.2093 3.93125Z",
            fill: "white"
        })
    });
};
const $ba4696cf403c7502$export$17670a653fa957a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "102",
        height: "31",
        viewBox: "0 0 102 31",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 6.34607H3.55597V14.2464H11.0557V6.34607H14.6163V25.739H11.0557V17.6727H3.55597V25.739H0V6.34607ZM25.8816 19.4224C25.8816 21.0458 24.559 22.3669 22.936 22.3669C21.3123 22.3669 19.9905 21.0458 19.9905 19.4224V11.0731H16.6182V19.4224C16.6182 22.9057 19.4525 25.739 22.936 25.739C26.4186 25.739 29.2527 22.9057 29.2527 19.4224V11.0731H25.8816V19.4224ZM38.6669 11.1709C36.9941 11.1709 35.8265 11.6563 34.6988 12.7632V6.34607H31.3156V18.2388C31.3156 22.6904 34.5341 25.739 38.15 25.739C42.1699 25.739 45.692 22.636 45.692 18.4551C45.692 14.3273 42.4442 11.1709 38.6669 11.1709ZM38.751 22.6091C36.4585 22.6091 34.7054 20.6945 34.7054 18.4551C34.7054 16.2154 36.4585 14.3002 38.751 14.3002C40.6935 14.3002 42.4476 16.2154 42.4476 18.4551C42.4476 20.6945 40.6935 22.6091 38.751 22.6091ZM51.3744 12.0232C51.3744 10.3225 52.5076 9.78333 53.7482 9.78333C54.7469 9.78333 56.0685 10.5387 56.931 11.4561L59.1427 8.86645C58.0373 7.38286 55.7986 6.35742 53.9641 6.35742C50.2948 6.35742 47.6509 8.48878 47.6509 12.0232C47.6509 18.5786 55.7176 16.5007 55.7176 20.1706C55.7176 21.3024 54.6118 22.3015 53.3446 22.3015C51.3475 22.3015 50.6997 21.3303 49.7828 20.3048L47.3274 22.8404C48.8931 24.756 50.8348 25.7276 53.1552 25.7276C56.635 25.7276 59.4409 23.5694 59.4409 20.1967C59.4409 12.913 51.3744 15.1794 51.3744 12.0232ZM68.3475 10.9809C64.732 10.9809 61.5131 14.0277 61.5131 18.4802V30.4037H64.8961V23.956C66.0239 25.0621 67.191 25.5484 68.8644 25.5484C72.6415 25.5484 75.8897 22.3924 75.8897 18.2645C75.8897 14.0831 72.3666 10.9809 68.3475 10.9809ZM68.9487 22.4195C66.6564 22.4195 64.9031 20.5022 64.9031 18.2645C64.9031 16.0248 66.6564 14.1096 68.9487 14.1096C70.8908 14.1096 72.6451 16.0248 72.6451 18.2645C72.6451 20.5022 70.8908 22.4195 68.9487 22.4195ZM100.793 22.6091C98.7974 22.6091 98.2309 21.7462 98.2309 20.4238V14.5699H101.333V11.6027H98.2309V7.69061L94.8058 9.22798V21.1522C94.8058 24.201 96.9093 25.739 99.7946 25.739C100.226 25.739 100.82 25.7111 101.144 25.6312L101.981 22.5561C101.603 22.5822 101.172 22.6091 100.793 22.6091Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.8684 14.7425C91.2198 13.6266 90.3075 12.7321 89.1669 12.0586C88.3146 11.5624 87.4308 11.2475 86.4348 11.1122V7.56661C87.4308 7.14373 88.0489 6.20773 88.0489 5.11576C88.0489 3.62739 86.8553 2.42129 85.3681 2.42129C83.8798 2.42129 82.6653 3.62739 82.6653 5.11576C82.6653 6.20773 83.2477 7.14373 84.2437 7.56661V11.1138C83.4469 11.229 82.6207 11.4774 81.8662 11.859C80.325 10.6885 75.2715 6.84873 72.3153 4.60602C72.3854 4.35325 72.4394 4.09271 72.4394 3.81782C72.4394 2.16931 71.1044 0.83313 69.4553 0.83313C67.8062 0.83313 66.4718 2.16931 66.4718 3.81782C66.4718 5.46614 67.8076 6.80271 69.4567 6.80271C70.0192 6.80271 70.5395 6.63818 70.9885 6.36768L71.6123 6.84096L80.1848 13.0175C79.7316 13.4336 79.3095 13.9069 78.9719 14.4379C78.2877 15.5205 77.8696 16.7117 77.8696 18.011V18.2821C77.8696 19.1942 78.0429 20.0554 78.3381 20.8643C78.598 21.5706 78.9781 22.2128 79.4488 22.7934L76.6037 25.6455C76.1914 25.492 75.7436 25.4605 75.3139 25.5548C74.8841 25.649 74.4906 25.865 74.1803 26.1769C73.9655 26.3907 73.7953 26.6449 73.6794 26.925C73.5636 27.205 73.5044 27.5053 73.5055 27.8083C73.5057 28.4244 73.7457 29.0035 74.1815 29.4391C74.3951 29.6541 74.6493 29.8245 74.9293 29.9406C75.2092 30.0566 75.5094 30.1159 75.8125 30.1151C76.1157 30.1159 76.416 30.0566 76.696 29.9405C76.9761 29.8245 77.2303 29.654 77.4441 29.4391C77.6588 29.2253 77.829 28.9712 77.9449 28.6913C78.0608 28.4113 78.1201 28.1113 78.1194 27.8083C78.1194 27.5699 78.0825 27.3372 78.0132 27.1161L80.9539 24.175C81.357 24.4535 81.7925 24.688 82.2606 24.8901C83.1838 25.2893 84.2029 25.5325 85.3182 25.5325H85.5225C86.7555 25.5325 87.9186 25.2429 89.012 24.6505C90.1641 24.0245 91.0658 23.1683 91.7471 22.0754C92.4319 20.9794 92.809 19.7685 92.809 18.4363V18.3698C92.809 17.0593 92.5056 15.8502 91.8684 14.7425ZM88.2754 20.9121C87.4772 21.7991 86.5597 22.3455 85.5225 22.3455H85.3516C84.7592 22.3455 84.1798 22.1817 83.6125 21.8839C82.9731 21.5561 82.487 21.0884 82.0892 20.4962C81.6781 19.9149 81.455 19.2803 81.455 18.6074V18.4031C81.455 17.7415 81.5819 17.1143 81.9018 16.5219C82.2438 15.8743 82.7057 15.3708 83.3201 14.9704C83.9232 14.5728 84.5674 14.3778 85.2849 14.3778H85.3516C86.0022 14.3778 86.6181 14.5061 87.1993 14.8035C87.7915 15.1206 88.2754 15.5538 88.6504 16.1237C89.0148 16.6938 89.2315 17.3087 89.3012 17.9786C89.3122 18.1178 89.3177 18.2604 89.3177 18.3967C89.3177 19.3058 88.9703 20.1478 88.2754 20.9121Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$faa4c35a40f54c9f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "74",
        height: "21",
        viewBox: "0 0 74 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.2467 4.39989C36.9006 3.47215 35.0814 3.13135 32.662 3.13135H28.0898V18.8903H32.759C34.4205 18.8903 35.8515 18.6694 37.0461 18.1708C38.2467 17.6596 39.1866 16.8518 39.8233 15.6842C40.46 14.5166 40.7935 13.002 40.7935 11.0708C40.7935 9.40462 40.5934 8.0351 40.175 6.93696C39.7506 5.83883 39.1139 5.00576 38.2467 4.39989ZM37.0218 13.7972C36.7975 14.5861 36.4337 15.1856 35.8758 15.6022C35.2573 16.0566 34.3295 16.3027 33.1835 16.3027H31.5462V5.72523H32.9227C34.2749 5.73154 35.2755 5.95243 35.9486 6.46994C36.4397 6.85492 36.7854 7.38506 37.0097 8.11084C37.2341 8.84293 37.3311 9.75804 37.3311 10.9004C37.3311 12.0427 37.2462 13.0146 37.0218 13.7972Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.9609 18.8903H46.4234V12.1752H50.4194V9.60658H46.4234V5.72523H52.5963V3.13135H42.9609V18.8903Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M54.7842 18.8912H58.2467V3.13232H54.7842C54.7842 3.13232 54.76 18.8912 54.7842 18.8912Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.4648 3.13135H69.9902V12.1752L63.5505 3.13135H60.7793V18.8903H64.2599V9.60658L70.6269 18.8903H73.4648V3.13135Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.0294 19.4902C14.7384 19.3703 14.4473 19.1368 13.6651 17.7673L12.1006 15.0787L10.2633 11.9042L10.1056 11.6329C10.1966 11.6076 10.2815 11.576 10.3724 11.5445C12.4826 10.7935 13.7136 8.78021 13.7136 5.91496C13.7136 4.49495 13.1618 3.18855 12.1127 2.21032C11.9611 2.07778 11.8035 1.94525 11.6337 1.82534C10.233 0.859735 8.34105 0.5 5.8185 0.5H1.05841H0.985639C0.676384 0.5 0.646065 0.683023 0.767342 0.853424C0.87649 0.99858 1.00383 1.20054 1.05234 1.70543V17.5275C0.997767 18.1712 0.870427 18.3795 0.767342 18.5246C0.646065 18.695 0.70064 18.8843 1.00989 18.878H4.53904V12.1756H6.13988L7.26775 14.1699L8.68669 16.6755L9.37796 17.8935C10.2512 19.4271 11.0152 20.2728 12.5433 20.4558C12.7494 20.4874 12.9738 20.5 13.2103 20.5C13.2285 20.5 13.4286 20.5 13.4468 20.5C13.9925 20.5 14.5322 20.2728 14.8597 20.1213C14.9021 20.1024 14.9506 20.0835 14.9931 20.0645C15.3872 19.8752 15.272 19.5912 15.0294 19.4902ZM6.77659 9.60697H4.65425H4.53297V3.13174H6.77659C7.88626 3.13174 8.72913 3.28321 9.36584 3.88277C9.60232 4.11628 9.77817 4.39397 9.91158 4.72846C10.0692 5.13869 10.1481 5.62465 10.1481 6.21789C10.142 7.07621 10.0632 9.60697 6.77659 9.60697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.5662 12.1752H23.5683V9.60658H19.5662V5.71891H25.7391V3.13135H16.0977V18.8903H25.7391V16.2774H19.5662V12.1752Z",
                fill: "white"
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDHCSStyle = null;
const $ba4696cf403c7502$export$559c708bf478ce1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dhcs-2416114995.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb10e3 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$export$2e83fbbf538f5ae7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "57",
        height: "34",
        viewBox: "0 0 57 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_7035_3621)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.2791 29.91C38.2336 29.8512 38.1835 29.8059 38.1153 29.7698C38.047 29.7336 37.9742 29.7109 37.8878 29.7109C37.8104 29.7109 37.7376 29.72 37.6694 29.7562C37.6012 29.7833 37.5466 29.8331 37.4965 29.8874C37.4465 29.9417 37.4192 30.0095 37.3919 30.0865C37.3646 30.1634 37.3555 30.2358 37.3555 30.3217V30.3308H38.4019C38.4019 30.2539 38.3928 30.1815 38.3746 30.1046C38.3564 30.0276 38.3291 29.9643 38.2791 29.9055V29.91Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1.32617 26.4219V34.0001H55.8044V26.4219H1.32617ZM14.3065 31.7741L13.9744 30.9145H12.6959L12.382 31.7741H11.9361L13.2009 28.4578H13.4876L14.7751 31.7741H14.3065ZM16.4767 29.8241C16.3994 29.7879 16.3266 29.7653 16.2401 29.7653C16.1628 29.7653 16.0763 29.7834 16.0035 29.8332C15.9171 29.8694 15.8307 29.9372 15.7351 30.0323V31.7651H15.2983V29.3989H15.6623L15.7215 29.6658C15.7988 29.5979 15.8625 29.5436 15.9217 29.4939C15.9808 29.4577 16.0354 29.417 16.0945 29.3989C16.14 29.3808 16.1992 29.3627 16.2356 29.3536C16.2811 29.3446 16.322 29.3446 16.3675 29.3446C16.4267 29.3446 16.4813 29.3536 16.5313 29.3627C16.5768 29.3808 16.6178 29.3989 16.6542 29.4215L16.4813 29.8287L16.4767 29.8241ZM18.0509 31.7741H17.7188L16.7952 29.3989H17.2411L17.878 31.1995H17.8871L18.6014 29.3989H19.0291L18.0464 31.7741H18.0509ZM20.8217 31.756L20.7261 31.5298C20.6988 31.566 20.6488 31.5977 20.6033 31.6338C20.5578 31.661 20.4987 31.6927 20.4395 31.7198C20.3804 31.7379 20.3167 31.756 20.2484 31.7786C20.1802 31.7877 20.1074 31.7967 20.0209 31.7967C19.9163 31.7967 19.8208 31.7877 19.7343 31.7515C19.6388 31.7243 19.5614 31.6746 19.4977 31.6112C19.4295 31.5524 19.3749 31.48 19.3339 31.385C19.2975 31.2991 19.2748 31.195 19.2748 31.0819C19.2748 30.8466 19.3612 30.6566 19.5205 30.5209C19.6843 30.3897 19.9208 30.3128 20.2348 30.3037L20.6897 30.2856V30.1997C20.6897 30.1137 20.6806 30.0368 20.6534 29.9734C20.6261 29.9101 20.5942 29.8603 20.5487 29.8241C20.5123 29.7879 20.4532 29.7563 20.3986 29.7382C20.344 29.7201 20.2757 29.711 20.2075 29.711C20.1301 29.711 20.0664 29.7201 20.0073 29.7291C19.939 29.7382 19.8844 29.7563 19.8344 29.7744C19.7889 29.7925 19.7389 29.8106 19.7025 29.8422C19.6661 29.8739 19.6251 29.8875 19.5887 29.9191L19.4249 29.616C19.5023 29.5572 19.5751 29.521 19.6433 29.4848C19.7116 29.4486 19.7844 29.417 19.8526 29.3989C19.9208 29.3717 19.9845 29.3627 20.0619 29.3536C20.1301 29.3446 20.2029 29.3446 20.2803 29.3446C20.4031 29.3446 20.5169 29.3627 20.6215 29.3898C20.7261 29.417 20.8126 29.4667 20.8899 29.5301C20.9673 29.5979 21.0219 29.6794 21.0719 29.7879C21.1174 29.892 21.1402 30.0232 21.1402 30.177V31.3217C21.1402 31.4167 21.1493 31.5026 21.1493 31.5569C21.1584 31.6158 21.1675 31.6429 21.1675 31.6791C21.1675 31.7153 21.1766 31.747 21.1857 31.7651H20.8126L20.8217 31.756ZM22.9555 31.747C22.8327 31.7922 22.7189 31.8148 22.6143 31.8148C22.5187 31.8148 22.4414 31.8058 22.3777 31.7786C22.314 31.7515 22.2549 31.7198 22.2139 31.6746C22.1684 31.6293 22.1366 31.5705 22.1184 31.5117C22.1002 31.4438 22.0911 31.3805 22.0911 31.3036V29.7698H21.6998V29.3989H22.0911V28.8695L22.5369 28.7293V29.4034H23.2603L23.1193 29.7653H22.5369V31.1588C22.5369 31.2538 22.5551 31.3307 22.5961 31.376C22.637 31.4212 22.6916 31.4438 22.769 31.4438C22.8054 31.4438 22.8463 31.4348 22.8827 31.4257C22.9191 31.4167 22.9601 31.4076 22.9965 31.3895C23.0329 31.3714 23.0647 31.3624 23.092 31.3443C23.1102 31.3171 23.1375 31.3081 23.1602 31.2855L23.2922 31.5886C23.1875 31.6655 23.0829 31.7198 22.9601 31.7605L22.9555 31.747ZM25.8218 31.0909C25.7627 31.2538 25.6808 31.385 25.5761 31.4981C25.4806 31.5931 25.3669 31.67 25.2349 31.7243C25.103 31.7696 24.9574 31.8012 24.7981 31.8012C24.4842 31.8012 24.234 31.7062 24.0383 31.5162C23.9337 31.4031 23.8472 31.2719 23.7927 31.109C23.7335 30.9462 23.7062 30.7697 23.7062 30.5797C23.7062 30.3897 23.7335 30.2178 23.7927 30.0594C23.8518 29.8965 23.9337 29.7653 24.0383 29.6522C24.1339 29.5482 24.2476 29.4712 24.3796 29.4169C24.5024 29.3581 24.648 29.331 24.8072 29.331C24.9801 29.331 25.1212 29.3581 25.2531 29.4169C25.3851 29.4758 25.4988 29.5482 25.5943 29.6522C25.699 29.7653 25.7854 29.8965 25.8218 30.0503C25.881 30.1997 25.9083 30.3806 25.9083 30.5706C25.9083 30.7607 25.881 30.9326 25.8218 31.0909ZM29.7755 31.281C29.7164 31.3941 29.6436 31.48 29.548 31.5569C29.4525 31.6339 29.3388 31.6881 29.2068 31.7379C29.0749 31.7741 28.9293 31.8058 28.7791 31.8058C28.6654 31.8058 28.5699 31.7967 28.4743 31.7786C28.3788 31.7605 28.2923 31.7424 28.215 31.7108C28.1376 31.6836 28.0739 31.6519 28.0057 31.6248C27.9374 31.5977 27.8919 31.5569 27.8328 31.5298L28.033 31.1905C28.0694 31.2176 28.1103 31.2493 28.1558 31.2764C28.2013 31.3036 28.2605 31.3352 28.3287 31.3533C28.3879 31.3714 28.4607 31.3895 28.5289 31.4122C28.6062 31.4303 28.679 31.4303 28.7564 31.4303C28.8246 31.4303 28.8974 31.4212 28.9748 31.4031C29.0521 31.385 29.1158 31.3579 29.175 31.3172C29.2341 31.2764 29.2796 31.2312 29.316 31.1769C29.3524 31.1181 29.3751 31.0457 29.3751 30.9688C29.3751 30.8828 29.357 30.7969 29.316 30.7335C29.2751 30.6702 29.2205 30.6023 29.1522 30.5435C29.084 30.4847 29.0112 30.4394 28.9247 30.3806C28.8383 30.3354 28.7518 30.2856 28.6654 30.2313C28.579 30.1861 28.4925 30.1273 28.4061 30.0684C28.3196 30.0096 28.2423 29.9463 28.1786 29.8694C28.1103 29.7925 28.0557 29.7065 28.0057 29.6115C27.9693 29.5165 27.9374 29.4034 27.9374 29.2722C27.9374 29.1591 27.9556 29.046 28.0057 28.9419C28.0512 28.8378 28.1103 28.7519 28.1968 28.675C28.2832 28.5981 28.3879 28.5438 28.5107 28.494C28.6335 28.4488 28.7791 28.4261 28.9293 28.4261C29.1022 28.4261 29.2523 28.4442 29.3751 28.4849C29.498 28.5257 29.6026 28.5619 29.68 28.5981L29.6709 29.0324C29.5662 28.9645 29.4616 28.9193 29.3297 28.8831C29.2068 28.8469 29.0703 28.8152 28.9384 28.8152C28.861 28.8152 28.7882 28.8243 28.72 28.8424C28.6517 28.8605 28.5971 28.8786 28.538 28.9193C28.4925 28.9555 28.4425 28.9962 28.4152 29.0505C28.3879 29.0957 28.3697 29.1636 28.3697 29.2405C28.3697 29.3265 28.3879 29.4034 28.4379 29.4667C28.4743 29.5346 28.5335 29.5979 28.6017 29.6477C28.6699 29.7065 28.7427 29.7608 28.8292 29.8106C28.9156 29.8603 29.0021 29.9146 29.0976 29.9599C29.1932 30.0051 29.2796 30.0639 29.3661 30.1318C29.4525 30.1906 29.5298 30.2539 29.5935 30.3309C29.6982 30.4168 29.7573 30.5028 29.7937 30.5978C29.8301 30.6928 29.862 30.8059 29.862 30.9281C29.862 31.0593 29.8347 31.1859 29.7755 31.29V31.281ZM31.5818 31.946C31.5044 32.1632 31.4316 32.3351 31.3452 32.4663C31.2587 32.5975 31.1723 32.7016 31.0858 32.7694C30.9994 32.8464 30.9039 32.8916 30.8083 32.9097C30.7128 32.9278 30.6172 32.9459 30.5126 32.9459C30.4079 32.9459 30.3215 32.9368 30.2441 32.9187C30.1668 32.9007 30.1031 32.8826 30.0349 32.8509L30.1486 32.5116C30.1941 32.5387 30.2532 32.5568 30.3124 32.5704C30.3715 32.5794 30.4352 32.5885 30.5035 32.5885C30.5717 32.5885 30.6354 32.5704 30.7037 32.5432C30.7719 32.5161 30.8356 32.4663 30.8948 32.403C30.9539 32.3396 31.0085 32.2537 31.0676 32.1451C31.1268 32.041 31.1723 31.9189 31.2087 31.7651L30.1304 29.3989H30.599L31.4089 31.2448H31.4271L32.0458 29.3989H32.4826L31.5772 31.946H31.5818ZM34.3935 31.4257C34.348 31.5117 34.2797 31.5886 34.1933 31.6429C34.1068 31.7017 34.0113 31.7379 33.8976 31.7651C33.7838 31.7922 33.6701 31.8012 33.5336 31.8012C33.4471 31.8012 33.3607 31.7922 33.297 31.7832C33.2197 31.7741 33.156 31.756 33.0968 31.7379C33.0377 31.7198 32.9831 31.7017 32.9239 31.67C32.8784 31.6519 32.8284 31.6248 32.792 31.5931L32.9421 31.2538C32.9785 31.2719 33.0195 31.2991 33.0559 31.3217C33.1014 31.3398 33.1423 31.3579 33.1969 31.3805C33.2561 31.3986 33.3015 31.4076 33.3607 31.4257C33.4198 31.4348 33.4744 31.4438 33.5427 31.4438C33.6109 31.4438 33.6746 31.4348 33.7338 31.4257C33.7929 31.4076 33.8384 31.3895 33.8839 31.3579C33.9203 31.3307 33.9613 31.2991 33.9795 31.2538C33.9977 31.2176 34.0159 31.1678 34.0159 31.1226C34.0159 31.0547 33.9977 31.0005 33.9704 30.9507C33.9431 30.9009 33.9021 30.8647 33.8475 30.8285C33.802 30.7923 33.7429 30.7607 33.6746 30.7335C33.6064 30.7064 33.5427 30.6747 33.4744 30.6476C33.4062 30.6204 33.3425 30.5797 33.2743 30.5435C33.206 30.5073 33.1514 30.4575 33.1014 30.4123C33.0559 30.3535 33.0058 30.2992 32.9785 30.2223C32.9512 30.1454 32.933 30.0594 32.933 29.9553C32.933 29.8694 32.9512 29.7834 32.9785 29.6975C33.0149 29.6205 33.065 29.5482 33.1287 29.4893C33.1924 29.4305 33.2788 29.3853 33.388 29.3491C33.4926 29.3129 33.6064 29.3038 33.752 29.3038C33.8839 29.3038 33.9977 29.3129 34.1023 29.34C34.2069 29.3581 34.2934 29.3989 34.3798 29.426V29.806C34.3343 29.7879 34.2843 29.7698 34.2479 29.7472C34.2024 29.7291 34.1523 29.7201 34.1068 29.702C34.0614 29.6929 34.0022 29.6748 33.9567 29.6748C33.8976 29.6658 33.843 29.6658 33.7838 29.6658C33.7247 29.6658 33.6701 29.6748 33.62 29.6839C33.57 29.6929 33.5245 29.711 33.4881 29.7291C33.4517 29.7472 33.4198 29.7744 33.4016 29.8151C33.3834 29.8558 33.3743 29.892 33.3743 29.9372C33.3743 29.9961 33.3925 30.0504 33.4198 30.0865C33.4471 30.1227 33.4972 30.1635 33.5427 30.1997C33.5882 30.2358 33.6473 30.2675 33.7156 30.2947C33.7838 30.3218 33.8475 30.3535 33.9158 30.3897C33.984 30.4168 34.0477 30.4575 34.116 30.4937C34.1842 30.5299 34.2388 30.5797 34.2888 30.634C34.3571 30.7109 34.3935 30.7652 34.4208 30.8421C34.4481 30.919 34.4663 31.005 34.4663 31.1C34.4663 31.2221 34.439 31.3352 34.3889 31.4212L34.3935 31.4257ZM36.1542 31.747C36.0314 31.7922 35.9176 31.8148 35.813 31.8148C35.7174 31.8148 35.6401 31.8058 35.5764 31.7786C35.5127 31.7515 35.4536 31.7198 35.4126 31.6746C35.3671 31.6293 35.3353 31.5705 35.3171 31.5117C35.2989 31.4438 35.2898 31.3805 35.2898 31.3036V29.7698H34.8985V29.3989H35.2898V28.8695L35.7356 28.7293V29.4034H36.459L36.318 29.7653H35.7356V31.1588C35.7356 31.2538 35.7538 31.3307 35.7948 31.376C35.8357 31.4212 35.8903 31.4438 35.9677 31.4438C36.0041 31.4438 36.045 31.4348 36.0814 31.4257C36.1178 31.4167 36.1588 31.4076 36.1952 31.3895C36.2316 31.3714 36.2634 31.3624 36.2907 31.3443C36.3089 31.3171 36.3362 31.3081 36.359 31.2855L36.4909 31.5886C36.3863 31.6655 36.2816 31.7198 36.1588 31.7605L36.1542 31.747ZM38.9068 30.6566H37.3917C37.3917 30.7697 37.4008 30.8647 37.4372 30.9597C37.4645 31.0547 37.5146 31.1407 37.5783 31.204C37.6374 31.281 37.7102 31.3352 37.8058 31.376C37.9013 31.4167 38.006 31.4348 38.1197 31.4348C38.2243 31.4348 38.329 31.4167 38.4245 31.376C38.5292 31.3398 38.6156 31.2991 38.7021 31.2538L38.8249 31.5569C38.7112 31.6429 38.5974 31.6972 38.4518 31.7379C38.3199 31.7741 38.1743 31.7967 38.0424 31.7967C37.8422 31.7967 37.6784 31.7605 37.5373 31.6927C37.3963 31.6248 37.278 31.5298 37.187 31.4167C37.096 31.3036 37.0232 31.1724 36.9777 31.0185C36.9322 30.8692 36.9095 30.7154 36.9095 30.5435C36.9095 30.3716 36.9277 30.2223 36.9777 30.0684C37.0232 29.9282 37.0915 29.7925 37.1779 29.6884C37.2644 29.5844 37.369 29.4984 37.4918 29.4305C37.6147 29.3627 37.7512 29.3355 37.9013 29.3355C38.0515 29.3355 38.197 29.3627 38.3108 29.4215C38.4245 29.4803 38.5292 29.5617 38.6156 29.6658C38.693 29.7698 38.7567 29.901 38.834 30.0368C38.8795 30.1861 38.9022 30.358 38.9022 30.539V30.6521L38.9068 30.6566ZM42.9651 31.7651H42.5193V30.2404C42.5193 30.1635 42.5102 30.1001 42.5011 30.0323C42.492 29.9644 42.4738 29.9191 42.4419 29.8694C42.4146 29.8241 42.3737 29.7834 42.3282 29.7563C42.2827 29.7291 42.2235 29.7201 42.1371 29.7201C42.0597 29.7201 41.996 29.7291 41.9369 29.7472C41.8687 29.7653 41.8141 29.7925 41.7549 29.8241C41.6958 29.8513 41.6412 29.892 41.5911 29.9282L41.4501 30.0413C41.4501 30.0413 41.4592 30.0775 41.4592 30.1001V31.7651H41.0133V30.2494C41.0133 30.1725 41.0042 30.1092 40.9951 30.0413C40.986 29.9734 40.9678 29.9191 40.936 29.8694C40.9041 29.8196 40.8677 29.7834 40.8222 29.7563C40.7767 29.7291 40.7085 29.7201 40.6311 29.7201C40.5538 29.7201 40.4901 29.7291 40.431 29.7472C40.3627 29.7653 40.3081 29.7925 40.249 29.8241C40.1898 29.8558 40.1352 29.892 40.0852 29.9282L39.9441 30.0413V31.747H39.4983V29.3808H39.8713L39.9305 29.6567C40.0806 29.5436 40.2262 29.4577 40.3582 29.3989C40.4901 29.34 40.6357 29.3129 40.7585 29.3129C40.8996 29.3129 41.027 29.3491 41.1316 29.4169C41.2362 29.4848 41.3136 29.5798 41.35 29.6929C41.4182 29.6341 41.4819 29.5798 41.5593 29.5301C41.6366 29.4803 41.7003 29.4441 41.7777 29.4079C41.855 29.3808 41.9187 29.3491 41.9961 29.331C42.0734 29.3129 42.1371 29.3038 42.2053 29.3038C42.3009 29.3038 42.3964 29.3129 42.4829 29.34C42.5693 29.3672 42.6467 29.4079 42.7195 29.4622C42.815 29.5572 42.8696 29.6432 42.9105 29.7382C42.9469 29.8332 42.9697 29.9553 42.9697 30.1092V31.7651H42.9651ZM45.1081 31.4303C45.0626 31.5117 44.9943 31.5886 44.9079 31.6429C44.8214 31.6972 44.7259 31.7379 44.6121 31.7651C44.4984 31.7922 44.3847 31.8012 44.2482 31.8012C44.1617 31.8012 44.0753 31.7922 44.0116 31.7832C43.9342 31.7741 43.8705 31.756 43.8114 31.7379C43.7522 31.7198 43.6976 31.7017 43.6385 31.6746C43.593 31.6565 43.543 31.6293 43.5066 31.6022L43.6567 31.2674C43.6931 31.2855 43.734 31.3126 43.7704 31.3307C43.8159 31.3488 43.8569 31.3669 43.9115 31.385C43.9706 31.4031 44.0161 31.4122 44.0753 31.4303C44.1344 31.4393 44.189 31.4484 44.2573 31.4484C44.3255 31.4484 44.3892 31.4393 44.4483 31.4303C44.5075 31.4122 44.553 31.3941 44.5985 31.3669C44.6349 31.3398 44.6758 31.3126 44.694 31.2629C44.7122 31.2267 44.7304 31.1814 44.7304 31.1317C44.7304 31.0683 44.7122 31.0095 44.6849 30.9643C44.6576 30.919 44.6167 30.8828 44.5621 30.8421C44.5166 30.8059 44.4574 30.7788 44.3892 30.7471C44.321 30.7199 44.2573 30.6928 44.189 30.6657C44.1208 30.6385 44.0571 30.6023 43.9888 30.5616C43.9206 30.5254 43.866 30.4802 43.8159 30.4304C43.7704 30.3761 43.7204 30.3173 43.6931 30.2449C43.6658 30.1725 43.6476 30.0865 43.6476 29.9825C43.6476 29.901 43.6658 29.8151 43.6931 29.7337C43.7295 29.6613 43.7795 29.5843 43.8432 29.5301C43.9069 29.4758 43.9934 29.426 44.1026 29.3898C44.2072 29.3536 44.321 29.3446 44.4665 29.3446C44.5985 29.3446 44.7122 29.3536 44.8169 29.3808C44.9215 29.3989 45.008 29.435 45.0944 29.4622V29.8332C45.0489 29.8151 44.9989 29.797 44.9625 29.7789C44.917 29.7608 44.8669 29.7517 44.8214 29.7337C44.7759 29.7156 44.7168 29.7065 44.6713 29.7065C44.6121 29.6975 44.5575 29.6975 44.4984 29.6975C44.4392 29.6975 44.3847 29.7065 44.3346 29.7156C44.2891 29.7246 44.2391 29.7427 44.2027 29.7608C44.1663 29.7789 44.1344 29.806 44.1162 29.8422C44.098 29.8784 44.0889 29.9146 44.0889 29.9644C44.0889 30.0187 44.1071 30.0775 44.1344 30.1137C44.1617 30.1499 44.2118 30.1861 44.2573 30.2268C44.3028 30.2675 44.3619 30.2901 44.4301 30.3218C44.4984 30.349 44.5621 30.3761 44.6303 30.4168C44.6986 30.444 44.7623 30.4802 44.8305 30.5209C44.8988 30.5616 44.9534 30.6023 45.0034 30.6611C45.0489 30.7154 45.099 30.7742 45.1263 30.8466C45.1627 30.9281 45.1854 31.014 45.1854 31.1181C45.1854 31.2402 45.1581 31.3488 45.1081 31.4348V31.4303Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M20.6989 30.6386L20.2712 30.6567C20.0801 30.6657 19.9391 30.7019 19.8526 30.7698C19.7662 30.8376 19.7207 30.9191 19.7207 31.0457C19.7207 31.1046 19.7298 31.1589 19.748 31.2086C19.7662 31.2539 19.7935 31.2946 19.8344 31.3308C19.8754 31.367 19.9118 31.3986 19.9664 31.4167C20.0255 31.4348 20.0892 31.4439 20.1575 31.4439C20.2348 31.4439 20.2894 31.4439 20.3486 31.4258C20.4077 31.4077 20.4532 31.3896 20.4987 31.367C20.5442 31.3443 20.5851 31.3217 20.6215 31.2901C20.6488 31.2629 20.6807 31.2448 20.708 31.2131H20.6989V30.634V30.6386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M13.4011 29.2857C13.3829 29.2178 13.3647 29.1636 13.3556 29.1047H13.3465C13.3283 29.1726 13.3101 29.2269 13.2874 29.2948C13.2646 29.3626 13.2419 29.435 13.21 29.5119L12.8506 30.5073H13.8197L13.4784 29.5119C13.4511 29.426 13.4193 29.349 13.4011 29.2857Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.2891 29.9373C25.23 29.8604 25.1663 29.7971 25.0798 29.7563C24.9934 29.7111 24.8979 29.6885 24.7932 29.6885C24.6886 29.6885 24.6021 29.7156 24.5157 29.7563C24.4383 29.8016 24.3746 29.8604 24.3155 29.9373C24.2563 30.0142 24.2199 30.1092 24.1926 30.2133C24.1653 30.3174 24.1562 30.4305 24.1562 30.5617C24.1562 30.6929 24.1744 30.8195 24.2017 30.9236C24.229 31.0277 24.2791 31.1227 24.3337 31.1996C24.3928 31.2765 24.4565 31.3398 24.543 31.3806C24.6203 31.4258 24.7159 31.4484 24.8205 31.4484C24.9252 31.4484 25.0207 31.4213 25.098 31.3806C25.1754 31.3353 25.2391 31.2765 25.2982 31.1996C25.3437 31.1227 25.3938 31.0277 25.4211 30.9236C25.4484 30.8195 25.4666 30.7064 25.4666 30.5752C25.4666 30.444 25.4484 30.3174 25.4211 30.2133C25.3847 30.1092 25.3437 30.0142 25.2891 29.9373Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M49.0617 17.776H49.8989V23.4585H49.2892L46.3183 19.3957V23.4585H45.4811V17.776H46.1863L49.0617 21.7076V17.776ZM42.401 17.7308L44.6394 23.4585H43.6794L43.1835 22.1058H40.9633L40.4673 23.4585H39.5438L41.8095 17.7308H42.401ZM42.906 21.3774L42.0688 19.0835L41.2317 21.3774H42.906ZM37.4008 17.776L35.7447 21.3457L34.0295 17.776H33.256L32.6555 23.4585H33.5609L33.9249 19.4636L35.5446 22.8342H35.8949L37.4964 19.3776L37.8786 23.4676H38.7657L38.1652 17.7851H37.4054V17.776H37.4008ZM29.0612 19.0926C29.0612 18.6175 29.4525 18.3551 30.0804 18.3551C30.6036 18.3551 31.1177 18.613 31.327 18.7442L31.6318 18.0611C31.4589 17.9479 30.822 17.6177 30.0622 17.6177C28.902 17.6177 28.1558 18.2239 28.1558 19.1605C28.1558 21.1602 30.9948 20.4001 30.9948 21.8524C30.9948 22.4406 30.4898 22.7256 29.7482 22.7256H28.6836L28.3424 23.4721H29.771C31.1313 23.4721 31.9048 22.7618 31.9048 21.7936C31.923 19.6536 29.0658 20.3142 29.0658 19.0926H29.0612ZM25.7354 17.776H24.8573V23.4585H27.6554L27.9966 22.712H25.7308V17.776H25.7354ZM21.3358 20.8435H23.3559V20.106H21.3358V18.5044H23.6789V17.767H20.4714V23.4495H23.7654V22.712H21.3358V20.848V20.8435ZM15.403 18.5135H17.0045V23.4585H17.8826V18.5135H19.4841V17.767H15.4075V18.5135H15.403ZM14.5931 19.4636C14.5931 18.5813 14.0699 17.776 12.7914 17.776H10.9989V23.4585H11.8542V18.4501H12.5776C13.2828 18.4501 13.6923 18.8845 13.6923 19.4455C13.6923 20.3051 13.0735 20.6082 12.2364 20.6082H12.1226L13.9698 23.4585H15.0345L13.4148 21.0426C14.0608 20.8254 14.584 20.3051 14.584 19.4591L14.5931 19.4636ZM7.28629 20.8435H9.31547V20.106H7.29539V18.5044H9.6385V17.767H6.43095V23.4495H9.72494V22.712H7.29539L7.28629 20.848V20.8435ZM5.30717 21.7845C5.30717 22.6758 4.68841 23.4902 3.15516 23.4902H1.32617V17.7489H3.17335C4.51552 17.7489 5.03874 18.4139 5.03874 19.1695C5.03874 19.7577 4.65656 20.1468 4.28803 20.3458C4.74301 20.5177 5.30717 20.8933 5.30717 21.7845ZM4.41998 21.8388C4.41998 21.0607 3.75117 20.7485 2.90492 20.7485H2.63649L2.94132 20.0744C3.38719 20.0744 4.16064 19.9974 4.16064 19.1921C4.16064 18.8121 3.91496 18.4366 3.08236 18.4366H2.16787V22.7935H3.12786C3.87856 22.7844 4.41543 22.4451 4.41543 21.8388H4.41998ZM54.9536 17.776V21.7076L52.0782 17.776H51.373V23.4585H52.2101V19.3957L55.1811 23.4585H55.7908V17.776H54.9536Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.0972 3.15343H45.5177V5.27532H43.0972V9.92628C43.0972 10.8945 43.4612 11.3288 44.3939 11.3288H45.2037V13.4416H43.3474C41.3274 13.4416 40.4811 12.288 40.4811 10.7135V5.27532H38.9479V3.15343H40.4811V0.787226L43.1018 0V3.15343H43.0972ZM37.3054 10.7226C37.3054 12.202 37.3509 12.9576 37.5056 13.4416H35.0761L34.8577 12.5323C34.1798 13.1385 33.238 13.6588 31.8685 13.6588C29.9622 13.6588 28.479 12.3151 28.479 10.2973C28.479 8.16633 30.1669 6.95383 32.8012 6.86786L34.6666 6.8V6.57379C34.6666 5.33413 33.7612 5.031 32.6647 5.031C31.732 5.031 29.7484 5.12601 29.7484 5.12601V3.167C29.7484 3.167 31.5955 3.07199 33.1879 3.07199C35.7403 3.07199 37.2918 4.04019 37.2918 6.73666V10.7226H37.3009H37.3054ZM34.6711 8.60067L33.1561 8.64591C31.7366 8.6821 31.0996 9.23407 31.0996 10.0937C31.0996 10.9533 31.6911 11.5912 32.7876 11.5912C33.7021 11.5912 34.3299 11.2428 34.6711 10.9397V8.60067ZM23.0011 9.83127L20.5898 3.15343H17.6871L21.8956 13.4281H23.8883L28.1833 3.15343H25.4898L23.0057 9.83127H23.0011ZM13.5332 3.15343H11.2947V13.4281H13.9518V6.26613C14.5614 5.69607 15.2939 5.59202 15.9127 5.59202C16.122 5.59202 16.3813 5.61916 16.6543 5.70512V3.13985C15.6715 3.13985 14.8526 3.28011 13.8244 4.23021L13.5286 3.1489L13.5332 3.15343ZM9.06082 10.7226C9.06082 12.202 9.10631 12.9576 9.261 13.4416H6.83146L6.61307 12.5323C5.93516 13.1385 4.99337 13.6588 3.62391 13.6588C1.71758 13.6588 0.234375 12.3151 0.234375 10.2973C0.234375 8.16633 1.92232 6.95383 4.5566 6.86786L6.42198 6.8V6.57379C6.42198 5.33413 5.51659 5.031 4.42011 5.031C3.48742 5.031 1.50374 5.12601 1.50374 5.12601V3.167C1.50374 3.167 3.35093 3.07199 4.94333 3.07199C7.49571 3.07199 9.04717 4.04019 9.04717 6.73666V10.7226H9.05627H9.06082ZM6.42198 8.60067L4.90693 8.64591C3.48742 8.6821 2.85046 9.23407 2.85046 10.0937C2.85046 10.9533 3.44192 11.5912 4.5384 11.5912C5.45289 11.5912 6.08075 11.2428 6.42198 10.9397V8.60067ZM56.8965 8.27944C56.8965 11.3876 54.8855 13.7629 51.6962 13.7629C48.5068 13.7629 46.5322 11.3967 46.5322 8.3654C46.5322 4.85003 48.9026 2.8322 51.7144 2.8322C54.5261 2.8322 56.8965 4.78217 56.8965 8.27944ZM54.2031 8.29754C54.2031 6.3159 53.2886 4.88623 51.6689 4.88623C50.0492 4.88623 49.2029 6.38377 49.2029 8.29754C49.2029 10.2113 50.1447 11.745 51.7371 11.745C53.3295 11.745 54.2031 10.2294 54.2031 8.29754Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_7035_3621",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "56.6667",
                        height: "34",
                        fill: "white",
                        transform: "translate(0.229492)"
                    })
                })
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDropboxStyle = null;
const $ba4696cf403c7502$export$3944c61ebd3bc79e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dropbox-2272682323.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbs0l4 _4t3izwfg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRobloxStyle = null;
const $ba4696cf403c7502$export$d76e3d65f440a2bb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox-1428046955.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialLumenStyle = null;
const $ba4696cf403c7502$export$2d5c2c6aa86b2349 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-lumen-3277500912.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3if6fq"
        ])
    });
};
const $ba4696cf403c7502$export$5ea2342df8447e77 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "89",
        height: "23",
        viewBox: "0 0 89 23",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.9993 21.1745C29.5465 21.1745 28.2194 19.926 28.2194 17.5961V10.7638H27.3641C26.9562 10.7589 26.5629 10.5918 26.2779 10.3018C25.9928 10.0118 25.8355 9.62348 25.8453 9.22042C25.865 8.40939 26.5384 7.76057 27.3641 7.75566H28.2194V5.72071C28.2931 4.81629 29.0599 4.1134 29.984 4.1134C30.9081 4.1134 31.6798 4.81138 31.7486 5.72071V7.75566H33.1249C33.5179 7.76704 33.8913 7.92991 34.1671 8.21022C34.4428 8.49053 34.5995 8.86658 34.6044 9.25974C34.5995 9.65291 34.4428 10.029 34.1671 10.3093C33.8913 10.5896 33.5179 10.7524 33.1249 10.7638H31.7486V16.672C31.7486 17.7043 32.4122 18.1073 32.9627 18.1073H33.2674C34.2603 18.1073 34.8158 18.7561 34.8158 19.6016C34.8158 20.447 34.2898 21.1745 31.9993 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43.035 21.1744C38.6505 21.1744 36.0012 18.0286 36.0012 14.2881C36.0012 10.577 38.6555 7.43119 43.035 7.43119C47.449 7.43119 50.0983 10.577 50.0983 14.2881C50.1278 15.2155 49.9639 16.1389 49.617 16.9996C49.2701 17.8602 48.7478 18.6392 48.0834 19.287C47.419 19.9347 46.627 20.4371 45.7579 20.762C44.8887 21.087 43.9614 21.2274 43.035 21.1744ZM43.035 10.4934C40.8526 10.4934 39.6434 12.2531 39.6434 14.2881C39.6434 16.323 40.8575 18.1171 43.035 18.1171C45.2125 18.1171 46.4561 16.3574 46.4561 14.2881C46.4561 12.2531 45.2125 10.4934 43.035 10.4934ZM62.48 21.0122H62.2048C61.9295 21.0122 60.6859 20.7959 60.6859 19.4934C59.7766 20.5502 58.2086 21.1744 56.4686 21.1744C54.3452 21.1744 51.8334 19.7637 51.8334 16.8342C51.8334 13.7719 54.3452 12.607 56.4686 12.607C58.2381 12.607 59.8061 13.1772 60.6859 14.2045V12.4399C60.6859 11.1128 59.5259 10.2427 57.7613 10.2427C56.707 10.2208 55.67 10.5134 54.7826 11.0833C54.5909 11.1997 54.3727 11.2657 54.1486 11.275C53.4113 11.2651 52.8214 10.6704 52.8214 9.94783C52.8253 9.70892 52.8914 9.47515 53.0131 9.26951C53.8389 7.96695 56.8176 7.42627 58.361 7.42627C61.3937 7.42627 64.1807 8.62069 64.1807 12.3858V19.3017C64.1856 20.2356 63.4238 21.0024 62.4702 21.0073L62.48 21.0122ZM60.6859 16.0772C60.1059 15.3203 59.0049 14.9369 57.8744 14.9369C56.4932 14.9369 55.3626 15.6349 55.3626 16.9178C55.3626 18.1368 56.4932 18.8446 57.8744 18.8446C59.0049 18.8446 60.1059 18.4661 60.6859 17.7042V16.0772Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.4687 21.1745C70.7336 21.1745 67.9466 20.6043 67.1209 19.4345C66.9587 19.2231 66.8702 18.9675 66.8751 18.7021C66.8853 18.3204 67.0431 17.9575 67.3154 17.6898C67.5876 17.4221 67.9531 17.2705 68.335 17.2668C68.5905 17.2668 68.8363 17.3356 69.0526 17.4683C70.0996 18.0631 71.4808 18.5251 72.6359 18.5251C74.1547 18.5251 74.8723 17.9304 74.8723 17.1144C74.8723 14.9468 66.9537 16.7065 66.9537 11.5552C66.9537 9.35805 68.915 7.43616 72.4147 7.43616C74.1498 7.43616 76.5239 7.98176 77.271 9.03364C77.414 9.22724 77.4915 9.46143 77.4922 9.70213C77.4676 10.4296 76.8581 11.0096 76.1159 11.0047C75.8848 11.0052 75.6571 10.9495 75.4523 10.8425C74.5313 10.328 73.4942 10.0573 72.4392 10.056C71.1711 10.056 70.3453 10.6262 70.3453 11.3586C70.3453 13.31 78.2344 11.683 78.2344 16.967C78.2344 19.3558 76.1651 21.1745 72.4687 21.1745ZM85.2928 21.1745C82.8401 21.1745 81.5129 19.926 81.5129 17.5961V10.7638H80.6577C80.2497 10.7589 79.8565 10.5918 79.5714 10.3018C79.2863 10.0118 79.129 9.62348 79.1388 9.22042C79.1585 8.4094 79.8319 7.76057 80.6577 7.75566H81.5129V5.72071C81.5534 5.28091 81.7569 4.87215 82.0834 4.57474C82.4099 4.27733 82.8359 4.11277 83.2775 4.11341C84.2016 4.11341 84.9733 4.81138 85.0421 5.72071V7.75566H86.4233C86.8164 7.76704 87.1898 7.92992 87.4655 8.21023C87.7412 8.49054 87.8979 8.86658 87.9028 9.25975C87.8979 9.65291 87.7412 10.029 87.4655 10.3093C87.1898 10.5896 86.8164 10.7524 86.4233 10.7638H85.0421V16.672C85.0421 17.7043 85.7057 18.1073 86.2562 18.1073H86.561C87.5539 18.1073 88.1044 18.7561 88.1044 19.6016C88.1044 20.447 87.5883 21.1745 85.2928 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5989 15.7873C23.6186 14.3373 23.5547 12.8872 23.4072 11.4471C23.2991 10.4738 22.9698 9.22533 21.913 8.96974C22.0492 9.00427 22.1924 8.99915 22.3259 8.95499C23.5498 8.316 23.4564 6.73818 23.0238 5.59783C22.4537 4.10357 21.1019 3.04186 19.7601 2.33897C17.2714 1.09804 14.5118 0.499666 11.7327 0.598398C8.95364 0.69713 6.24345 1.48982 3.84917 2.90423C2.63509 3.65136 1.23914 5.11121 1.85355 6.73818C2.02012 7.14309 2.26576 7.51071 2.5761 7.81955L3.03814 8.30125C2.4139 9.14669 1.95677 9.91348 1.66185 10.9408C0.777095 14.0374 0.924555 16.0281 1.16541 18.5153C1.31778 20.0538 1.82406 22.3443 3.59849 22.5999C5.04359 22.8015 6.61158 22.3247 8.05668 22.1526C9.64925 21.9658 11.2566 21.6709 12.8688 21.7152C15.1397 21.7741 17.3909 22.3099 19.6667 22.3345C20.866 22.3443 22.8616 22.4623 23.2204 20.8796C23.5596 19.3755 23.5744 17.8124 23.5744 16.2788C23.594 16.1166 23.594 15.9495 23.594 15.7922L23.5989 15.7873ZM21.0036 18.3875C20.4384 19.6606 18.8409 19.518 17.7251 19.4246L12.7361 18.8299C11.2516 18.7856 9.78196 19.0658 8.33686 19.3853C7.25549 19.6212 5.74648 20.2455 4.76834 19.4148C3.68205 18.4956 3.49035 16.9276 3.47561 15.6054C3.49602 14.4115 3.61438 13.2213 3.82951 12.0467C3.96222 11.3193 4.1785 10.6115 4.46359 9.93314C4.8519 8.95008 5.42699 8.35532 5.45648 8.38481C5.16648 8.08498 4.81749 7.92277 4.62088 7.5148C3.87866 5.96648 5.73174 4.65409 6.74429 4.20679C10.2882 2.62406 15.2429 2.78135 18.5902 4.81138C19.6323 5.44545 21.6574 7.62294 19.765 8.70922C20.9299 9.25974 21.2297 10.9211 21.3575 12.1008C21.562 13.9955 21.5024 15.9095 21.1806 17.7878C21.1458 17.9947 21.0896 18.1962 21.0036 18.3875Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$13c02cb17fc407de = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "29",
        viewBox: "0 0 103 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.4863 0.270996L29.6308 22.1619H32.9144V0.270996H29.4863ZM70.1289 0.270996V22.1706H74.0802C74.0802 22.1706 74.113 14.268 74.1568 14.2768C74.2006 14.2768 80.0476 22.4705 80.1002 22.4421C80.1593 22.4267 83.6049 21.1877 83.6049 21.1527C83.6049 21.1264 77.7316 13.62 77.7316 13.6113C77.7316 13.5938 82.657 8.11231 82.6132 8.06852C82.4775 7.94156 79.809 6.78791 79.7324 6.8295C79.6974 6.85577 74.0802 12.9524 74.0802 12.9524V0.270996H70.1289ZM4.6708 6.94771C3.25009 7.24761 1.91693 8.15609 1.36966 9.20685C1.1214 9.71444 0.993808 10.2725 0.996846 10.8376C0.999884 11.4026 1.13347 11.9593 1.38717 12.4642C1.73743 13.1406 2.75535 14.0819 4.33587 15.1918C6.04774 16.4068 6.69571 17.0131 6.85989 17.5867C7.10726 18.4338 6.73073 19.2285 5.90983 19.6225C5.50047 19.8195 5.31877 19.8436 4.592 19.8108C3.64412 19.767 2.99396 19.5262 2.02858 18.8344C1.71992 18.6221 1.43752 18.4667 1.4025 18.5017C1.36966 18.5367 1.061 18.9986 0.719503 19.5284L0.10437 20.4763L0.334224 20.6558C0.472137 20.7499 0.881496 20.9995 1.25802 21.2118C3.85865 22.6566 7.70488 22.4267 9.65535 20.7083C10.1652 20.2713 10.5541 19.7106 10.7849 19.08C11.0156 18.4494 11.0805 17.7701 10.9732 17.1073C10.7849 15.8332 10.0822 14.997 7.87563 13.3968C6.14187 12.1402 5.32096 11.4485 5.1327 11.0807C4.76494 10.3605 5.02106 9.66874 5.79818 9.26595C6.19222 9.06237 6.35421 9.04486 7.13353 9.07769C7.89314 9.10396 8.12518 9.16525 8.75783 9.46297L9.49336 9.82198L10.0647 8.92445C10.3821 8.42972 10.612 7.9919 10.5879 7.95031C10.485 7.79707 9.27883 7.2914 8.52579 7.09657C7.52537 6.8295 5.59241 6.75288 4.6708 6.9499V6.94771ZM22.0368 8.88286C23.7662 9.69283 24.6878 12.2322 24.3135 15.1239C24.1821 16.1506 23.8166 17.3897 23.4751 17.9632C23.1314 18.5542 22.4659 19.1956 21.9339 19.443C20.9598 19.9027 19.515 19.7254 18.6 19.0315C17.3347 18.0661 16.6407 15.6975 16.9056 13.2348C17.1552 10.9778 17.9673 9.54835 19.3858 8.88943C20.1214 8.54793 21.3122 8.54793 22.0368 8.88286ZM20.4629 6.3676C19.4296 6.59965 18.6087 7.06154 17.7199 7.90653L16.9144 8.67709V6.83826H13.2126V28.7291H16.9144V19.802L17.6258 20.4938C18.9239 21.7678 20.4475 22.2823 22.2251 22.0327C23.3875 21.8707 24.2084 21.573 25.0731 20.9907C27.503 19.3664 28.8449 16.1244 28.4771 12.7378C28.1269 9.52426 26.4763 7.30016 23.8144 6.45517C23.1314 6.23188 21.2663 6.1881 20.4629 6.3676ZM35.6683 6.83826C35.6683 6.83826 35.7887 18.4076 35.8653 18.7425C36.163 20.0166 37.0189 21.2293 37.9778 21.7525C38.8578 22.2297 39.567 22.3764 40.8936 22.3764C42.7828 22.3676 43.9277 21.9145 45.3309 20.6229L46.0489 19.9728V22.1619H49.8623L49.812 6.83826H46.0489C46.0489 6.83826 46.0993 16.3564 46.0489 16.6891C45.8256 18.0245 44.7924 19.119 43.7394 19.4693C43.1155 19.6816 42.021 19.8524 41.3621 19.7495C40.6878 19.64 39.5495 18.8957 39.4817 17.7837V6.88861L35.6683 6.83826ZM67.375 22.1619C67.375 22.1619 67.2546 10.5925 67.178 10.2576C66.8803 8.98356 66.0243 7.77081 65.0655 7.24762C64.1855 6.7704 63.4762 6.62373 62.1496 6.62373C60.2605 6.63248 59.1156 7.08562 57.7124 8.37718L56.9944 9.02734V6.83826H53.181L53.2313 22.1619H56.9944C56.9944 22.1619 56.944 12.6437 56.9944 12.311C57.2176 10.9756 58.2509 9.88109 59.3038 9.53083C59.9277 9.31849 60.7486 9.1565 61.6812 9.25063C62.6115 9.35133 63.6295 10.1985 63.5616 11.2164V22.1115L67.375 22.1619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.6399 5.74365V9.02728L100.774 13.4055L87.6399 19.1015V22.1618L102.963 15.5945V11.2164L87.6399 5.74365Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$9deaa7e38ca0abdf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$var$testimonialDoodleStyle = null;
const $ba4696cf403c7502$export$72c6ec790fc33a37 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-doodle-1380981062.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRoyalCaribbeanStyle = null;
const $ba4696cf403c7502$export$ea2a07b098c3c428 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-royal-caribbean-3438806072.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbhcro _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialMercedesBenzStyle = null;
const $ba4696cf403c7502$export$3192ac60f265126c = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-mercedes-benz-2937659039.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbwz92 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialSunLifeStyle = null;
const $ba4696cf403c7502$export$53d258996873a1e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-sun-life-resize-2840009056.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb18cf _4t3i1u1b"
        ])
    });
const $ba4696cf403c7502$var$testimonialUnitedStyle = null;
const $ba4696cf403c7502$export$6a1b58616eb8f4e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-united-resize-2634290916.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1u1b"
        ])
    });

});


parcelRegister("kkULZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b44003f57f0b2933$export$2e2bcd8739ae039; });
/* why-confluence-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kNEse = parcelRequire("kNEse");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $6yWka = parcelRequire("6yWka");

var $kbpa7 = parcelRequire("kbpa7");
const $b44003f57f0b2933$var$whyConfluenceSectionStyles = null;
const $b44003f57f0b2933$var$whyBackgroundStyles = null;
const $b44003f57f0b2933$var$relative = null;
const $b44003f57f0b2933$var$whyConfluenceSectionHeaderStyles = null;
const $b44003f57f0b2933$var$infoCardContainerStyles = null;
const $b44003f57f0b2933$var$infoBoxGroup = null;
const $b44003f57f0b2933$var$WhyConfluenceSection = ()=>{
    const intl = (0, $8e22h.default)();
    const infoBoxes1 = [
        {
            infoBoxId: 'versatileContentCreation',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).versatileContentCreationInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).versatileContentCreationInfoBoxParagraph)
        },
        {
            infoBoxId: 'organizationThatScales',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).organizationThatScalesInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).organizationThatScalesInfoBoxParagraph)
        }
    ];
    const infoBoxes2 = [
        {
            infoBoxId: 'powerfulIntegrations',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxParagraph)
        },
        {
            infoBoxId: 'dataProtection',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).dataProtectionInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).dataProtectionInfoBoxParagraph)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-whyConfluenceSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _1q51ys9h _85i5vbgk _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz1sm8 _bfhkg7ng _p12f1git _1bsb1osq _1tkekbql _4t3i1osq _152tidpf _h15z5580 _1vth1k1d _tnru1osq"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_1pfhidpf _6rth8vuz _gu181h6o"
                            ]),
                            children: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).whyConfluenceSectionHeader)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _1n261g80 _zulpzwfg _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes1.map((infoCardProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6yWka.InfoBox), {
                                            ...infoCardProps
                                        }, infoCardProps.infoBoxId))
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes2.map((infoCardProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6yWka.InfoBox), {
                                            ...infoCardProps
                                        }, infoCardProps.infoBoxId))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$b44003f57f0b2933$var$WhyConfluenceSection.displayName = 'WhyConfluenceSection';
var $b44003f57f0b2933$export$2e2bcd8739ae039 = $b44003f57f0b2933$var$WhyConfluenceSection;

});
parcelRegister("kNEse", function(module, exports) {
$parcel$export(module.exports, "whyConfluenceSectioni18n", function () { return $395e8cc883a0ecbc$export$ab4765e2b00a177e; });

var $fnHPc = parcelRequire("fnHPc");
const $395e8cc883a0ecbc$export$ab4765e2b00a177e = (0, $fnHPc.defineMessages)({
    whyConfluenceSectionHeader: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.Header',
        defaultMessage: 'Why Confluence?'
    },
    versatileContentCreationInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Title',
        defaultMessage: 'Versatile content creation'
    },
    versatileContentCreationInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Paragraph',
        defaultMessage: 'Bring your ideas to life with a rich palette of content: Whiteboards, Databases, and videos within every Confluence Page.'
    },
    organizationThatScalesInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Title',
        defaultMessage: 'Organization that scales'
    },
    organizationThatScalesInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Paragraph',
        defaultMessage: "You\u2019ll never outgrow Confluence. Project resources and company knowledge stay centralized and discoverable."
    },
    powerfulIntegrationsInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Title',
        defaultMessage: 'Powerful integrations'
    },
    powerfulIntegrationsInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Paragraph',
        defaultMessage: 'Connect Confluence to thousands of your favorite tools to access data and manage workflows across apps.'
    },
    dataProtectionInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Title',
        defaultMessage: 'Data protection'
    },
    dataProtectionInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Paragraph',
        defaultMessage: 'User-level permissions keep your information private. Company data stays secure and always remains in your control.'
    }
});

});

parcelRegister("6yWka", function(module, exports) {
$parcel$export(module.exports, "InfoBox", function () { return $b4c01eb6d52c7791$export$aff4fc93593c3bcf; });
/* info-box.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $b4c01eb6d52c7791$var$infoBoxContainerStyles = null;
const $b4c01eb6d52c7791$var$imageStyles = null;
const $b4c01eb6d52c7791$var$titleStyles = null;
const $b4c01eb6d52c7791$var$paragraphStyles = null;
const $b4c01eb6d52c7791$export$aff4fc93593c3bcf = ({ imageUrl: imageUrl, imageHeight: imageHeight, imageWidth: imageWidth, containerWidth: containerWidth, title: title, paragraph: paragraph })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            width: containerWidth ?? 290
        },
        className: (0, $2jatx.default)([
            "_1e0c1txw _1tke1kr5 _2lx21bp4 _1bah1h6o _4cvr1y6m _1o9zidpf"
        ]),
        children: [
            imageUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                src: imageUrl,
                alt: title,
                height: imageHeight ? imageHeight : '100%',
                width: imageWidth ? imageWidth : '100%',
                className: (0, $2jatx.default)([
                    "_p12f1osq _6rth19bv"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4u2gc _1e0c1txw _2lx2vrvc _4cvrv2br",
                    "h4"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1tke1obz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _1yt4u2gc"
                ]),
                children: paragraph
            })
        ]
    });
};

});






//# sourceMappingURL=confluence-software-page.251bc833.js.map
